import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React, { useState, useRef, useEffect, forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Snackbar$1, { Snackbar } from '@andes/snackbar';
import FloatingMenu$1, { FloatingMenu, FloatingMenuGroup, FloatingMenuItem } from '@andes/floating-menu';
import ChevronDown12 from '@andes/icons/ChevronDown12';
import ChevronRight12 from '@andes/icons/ChevronRight12';
import { useMessage } from '@mshops-components-library/message-hooks';
import MelidataTracker from '@mshops-web-core/melidata-tracker';
import Button$1, { Button } from '@andes/button';
import Tooltip$1, { Tooltip } from '@andes/tooltip';
import restclient from 'frontend-restclient';
import { c as constants_1$1, a as constants$1 } from './constants-3a99a351.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import FacebookLogo from '@mshops-web-components/logos/FacebookLogo';
import InstagramLogo from '@mshops-web-components/logos/InstagramLogo';
import WhatsAppLogo from '@mshops-web-components/logos/WhatsAppLogo';
import XLogo from '@mshops-web-components/logos/XLogo';
import Share16 from '@andes/icons/Share16';
import Mail20 from '@andes/icons/Mail20';
import Link16 from '@andes/icons/Link16';
import ChevronUp12 from '@andes/icons/ChevronUp12';
import ChevronRight20 from '@andes/icons/ChevronRight20';
import Image from 'frontend-image';
import VerifiedLogo from '@mshops-web-components/logos/VerifiedLogo';
import { Image as Image$1 } from '@andes/common';
import OverflowMenuVertical16 from '@andes/icons/OverflowMenuVertical16';
import Markdown from 'markdown-to-jsx';
import { Modal } from '@andes/modal';
import List, { ListItem } from '@andes/list';
import ArrowLeft24 from '@andes/icons/ArrowLeft24';
import Close24 from '@andes/icons/Close24';
import { Pill } from '@andes/badge';
import { SegmentedControl, Segment } from '@andes/segmented-control';
import { Tabs, Tab } from '@andes/tabs';
import Close20 from '@andes/icons/Close20';
import { Card as Card$1, CardContent } from '@andes/card';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { ThumbnailMultiple, Thumbnail } from '@andes/thumbnail';
import ChevronLeft20 from '@andes/icons/ChevronLeft20';
import ChevronRight32 from '@andes/icons/ChevronRight32';
import ChevronLeft32 from '@andes/icons/ChevronLeft32';
import PlaceholderImage48 from '@andes/icons/PlaceholderImage48';
import AndesBottomSheet, { BottomSheetHeader as BottomSheetHeader$1 } from '@andes/bottom-sheet';
const MELIDATA_PATH = '/eshops/menu';
const menuView = _ref => {
  let {
    shopType,
    ownerId,
    buyerId,
    officialStoreId,
    shopName,
    trackingId,
    shopId
  } = _ref;
  return MelidataTracker.notify({
    path: MELIDATA_PATH,
    data: {
      shop_type: shopType || 'none',
      owner_id: ownerId || 'none',
      buyer_id: buyerId || 'none',
      official_store_id: officialStoreId || -1,
      shop_name: shopName || 'none',
      tracking_id: trackingId || 'none',
      shop_id: shopId || 'none'
    },
    type: 'view'
  });
};
const PATHS = {
  MENU: 'menu',
  FOLLOW: 'follow',
  SHARE: 'share',
  FOLLOW_COUPON: '/eshops/follow/coupons',
  RENDER_COMPONENT: '/eshops/profile_header'
};
const getExtraData = (extraData, path) => extraData[path];
const getPathName = url => {
  try {
    const urlObject = new URL(url);
    return urlObject.pathname;
  } catch (e) {
    return '';
  }
};
const sendTrack = (path, data, type, extraData) => {
  const additionalData = extraData && getExtraData(extraData, path);
  const fullData = _objectSpread(_objectSpread({}, data), additionalData || {});
  MelidataTracker.notify({
    path,
    data: fullData,
    type
  });
};
const MelidataTrack = {
  menuView,
  getPathName,
  sendTrack,
  PATHS
};
const obtainFollowCta = (ctas, ctaStatus) => {
  if (ctas && ctaStatus) {
    return ctas === null || ctas === void 0 ? void 0 : ctas.filter(cta => (cta === null || cta === void 0 ? void 0 : cta.id) === ctaStatus)[0];
  }
  return null;
};

/* eslint-disable import/no-extraneous-dependencies */
const setFollower = async _ref => {
  let {
    baseURL,
    ownerId,
    buyerId,
    entityId,
    entityType,
    action,
    withAudience = false,
    queryParam = {}
  } = _ref;
  const httpClient = restclient({
    baseURL,
    timeout: 10000
  });
  try {
    const response = await httpClient.post('/set-follower', {
      data: {
        ownerId,
        buyerId,
        entityId,
        entityType,
        action,
        withAudience,
        queryParam
      }
    });
    return response;
  } catch (err) {
    throw new Error(err);
  }
};
const deleteFollower = async _ref2 => {
  let {
    baseURL,
    ownerId,
    buyerId,
    entityId,
    entityType,
    action,
    queryParam = {}
  } = _ref2;
  const httpClient = restclient({
    baseURL,
    timeout: 10000
  });
  try {
    const response = await httpClient.post('/delete-follower', {
      data: {
        ownerId,
        buyerId,
        entityId,
        entityType,
        action,
        queryParam
      }
    });
    return response;
  } catch (e) {
    throw new Error(e);
  }
};
var _svg$4;
const namespace$b = 'ui-ms-profile__coupon-icon';
const Coupon = () => _svg$4 || (_svg$4 = /*#__PURE__*/_jsx("svg", {
  className: namespace$b,
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, /*#__PURE__*/_jsx("path", {
  d: "M2 2.94446C2 2.11603 2.67157 1.44446 3.5 1.44446H12.5C13.3284 1.44446 14 2.11603 14 2.94446V3.93598C14 4.03394 13.9263 4.11623 13.829 4.12705C11.5938 4.3754 11.5938 7.62463 13.829 7.87298C13.9263 7.8838 14 7.96609 14 8.06405V9.05557C14 9.884 13.3284 10.5556 12.5 10.5556H3.5C2.67157 10.5556 2 9.884 2 9.05557V2.94446Z",
  stroke: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M9.67582 5.14848L8.33448 5.04117C8.28082 5.04117 8.22717 5.0054 8.20928 4.95175L7.70852 3.69983C7.58332 3.39579 7.17198 3.39579 7.04679 3.69983L6.54602 4.95175C6.52814 5.0054 6.47448 5.04117 6.42083 5.04117L5.07949 5.13059C4.75757 5.14848 4.63237 5.55982 4.88276 5.75655L5.90218 6.61501C5.93795 6.65078 5.95583 6.70443 5.95583 6.75809L5.61603 8.08154C5.54449 8.38558 5.88429 8.63596 6.15256 8.475L7.29717 7.75962C7.35083 7.72385 7.40448 7.72385 7.45813 7.75962L8.60274 8.475C8.87101 8.63596 9.21082 8.40346 9.13928 8.08154L8.79947 6.77597C8.78159 6.72232 8.79947 6.66866 8.85313 6.63289L9.89043 5.75655C10.1229 5.55982 9.99774 5.16636 9.67582 5.14848Z",
  fill: "#3483FA"
})));
var _Coupon, _Coupon2;
const Followers = _ref => {
  var _global;
  let {
    namespace,
    followers,
    isMobile,
    ownerId,
    buyerId,
    baseURL,
    type,
    siteId,
    tracks,
    barInfo = {},
    deviceType,
    handlePostFollow = () => {},
    flowSource
  } = _ref;
  const {
    text,
    cta_status: ctaStatus,
    ctas
  } = followers || {};
  const [followState, setFollowState] = useState(ctaStatus);
  const [followerQuantity, setFollowerQuantity] = useState(text);
  const [disabledClick, setDisabledClick] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(constants_1$1.DEFAULT_STATE_SNACKBAR);
  const followCta = obtainFollowCta(ctas, followState);
  const isDisabled = !ownerId || ownerId === buyerId;
  const apiURL = baseURL || '/api';
  const didMount = useRef(false);
  const browserUrl = (_global = global) === null || _global === void 0 || (_global = _global.location) === null || _global === void 0 ? void 0 : _global.href;
  const {
    entity_id: entityId
  } = (followers === null || followers === void 0 ? void 0 : followers.follows_entity) || '';
  const {
    entity_type: entityType
  } = (followers === null || followers === void 0 ? void 0 : followers.follows_entity) || '';
  const withCoupon = (barInfo === null || barInfo === void 0 ? void 0 : barInfo.visible) && (barInfo === null || barInfo === void 0 ? void 0 : barInfo.icon) === 'coupon' && followState === 'do_follow';
  const withButtonInMobile = constants_1$1.BUTTON_MOBILE_FOLLOWER.includes(type === null || type === void 0 ? void 0 : type.toLowerCase());
  const {
    with_follow_coupon: withFollowCoupon
  } = barInfo;
  const getActionFollow = () => {
    if (followState === 'do_follow') {
      return withCoupon ? 'do_follow_incentive' : 'do_follow';
    }
    return 'stop_follow';
  };
  const handleCallPostFollow = action => {
    if (withFollowCoupon || withCoupon) {
      handlePostFollow({
        action
      });
    }
  };
  const trackFollow = _ref2 => {
    let {
      action
    } = _ref2;
    if (tracks && (withFollowCoupon || withCoupon)) {
      var _data$client, _data$client$toLowerC, _data$shop_type, _data$shop_type$toLow;
      const {
        melidata_track: melidataTrack
      } = tracks;
      const {
        event_data: data
      } = melidataTrack;
      const newData = {
        action,
        section: data === null || data === void 0 || (_data$client = data.client) === null || _data$client === void 0 || (_data$client$toLowerC = _data$client.toLowerCase) === null || _data$client$toLowerC === void 0 ? void 0 : _data$client$toLowerC.call(_data$client),
        buyer_id: buyerId === null || buyerId === void 0 ? void 0 : buyerId.toString(),
        storefront_id: data === null || data === void 0 ? void 0 : data.shop_id,
        storefront_name: data === null || data === void 0 ? void 0 : data.shop_name,
        storefront_type: data === null || data === void 0 || (_data$shop_type = data.shop_type) === null || _data$shop_type === void 0 || (_data$shop_type$toLow = _data$shop_type.toLowerCase) === null || _data$shop_type$toLow === void 0 ? void 0 : _data$shop_type$toLow.call(_data$shop_type),
        origin: 'header',
        flow_source: flowSource || 'NOT_SPECIFIED'
      };
      MelidataTrack.sendTrack(MelidataTrack.PATHS.FOLLOW_COUPON, newData, 'event');
    }
  };
  const onClickHandler = () => {
    var _tracks$melidata_trac;
    const actionFollow = getActionFollow();
    if (tracks) {
      var _data$client2, _data$client2$toLower;
      const {
        melidata_track: melidataTrack,
        paths,
        extra_data: extraData
      } = tracks;
      const {
        event_data: data,
        type: trackType
      } = melidataTrack;
      const validateClientTrack = ['home', 'search', 'vpp'].includes(data === null || data === void 0 || (_data$client2 = data.client) === null || _data$client2 === void 0 || (_data$client2$toLower = _data$client2.toLowerCase) === null || _data$client2$toLower === void 0 ? void 0 : _data$client2$toLower.call(_data$client2)) ? data.client.toLowerCase() : 'no_valid_client';
      const newData = _objectSpread(_objectSpread({}, data), {}, {
        action: followState,
        shop_type: data === null || data === void 0 ? void 0 : data.shop_type.toLowerCase(),
        client: validateClientTrack,
        flow_source: flowSource || 'NOT_SPECIFIED'
      });
      MelidataTrack.sendTrack(paths[MelidataTrack.PATHS.FOLLOW], newData, trackType, extraData);
    }
    const client = (tracks === null || tracks === void 0 || (_tracks$melidata_trac = tracks.melidata_track) === null || _tracks$melidata_trac === void 0 || (_tracks$melidata_trac = _tracks$melidata_trac.event_data) === null || _tracks$melidata_trac === void 0 ? void 0 : _tracks$melidata_trac.client) || '';
    if (!buyerId && isMobile) {
      localStorage.setItem('followLogin', ownerId === null || ownerId === void 0 ? void 0 : ownerId.toString());
      localStorage.setItem(`CP_Login_${ownerId}`, 'true');
      window.location = 'meli://login/?authentication_mode=required';
    } else if (!buyerId) {
      localStorage.setItem('followLogin', ownerId === null || ownerId === void 0 ? void 0 : ownerId.toString());
      localStorage.setItem(`CP_Login_${ownerId}`, 'true');
      window.location = `https://www.mercadolibre.com/jms/${siteId === null || siteId === void 0 ? void 0 : siteId.toLowerCase()}/lgz/login?platform_id=ML&go=${encodeURIComponent(browserUrl)}`;
    } else if (followState === 'do_follow') {
      var _tracks$melidata_trac2, _tracks$melidata_trac3, _tracks$melidata_trac4, _ctas$;
      setFollower({
        baseURL: apiURL,
        ownerId,
        entityId: tracks === null || tracks === void 0 || (_tracks$melidata_trac2 = tracks.melidata_track) === null || _tracks$melidata_trac2 === void 0 || (_tracks$melidata_trac2 = _tracks$melidata_trac2.event_data) === null || _tracks$melidata_trac2 === void 0 ? void 0 : _tracks$melidata_trac2.shop_id,
        entityType,
        withAudience: withCoupon,
        action: actionFollow,
        queryParam: {
          shopType: tracks === null || tracks === void 0 || (_tracks$melidata_trac3 = tracks.melidata_track) === null || _tracks$melidata_trac3 === void 0 || (_tracks$melidata_trac3 = _tracks$melidata_trac3.event_data) === null || _tracks$melidata_trac3 === void 0 ? void 0 : _tracks$melidata_trac3.shop_type,
          device: deviceType,
          source: client,
          ownerId: tracks === null || tracks === void 0 || (_tracks$melidata_trac4 = tracks.melidata_track) === null || _tracks$melidata_trac4 === void 0 || (_tracks$melidata_trac4 = _tracks$melidata_trac4.event_data) === null || _tracks$melidata_trac4 === void 0 ? void 0 : _tracks$melidata_trac4.owner_id,
          siteId
        }
      }).then(() => {
        if (withCoupon && barInfo !== null && barInfo !== void 0 && barInfo.snackbar_success) {
          setShowSnackbar(_objectSpread(_objectSpread({}, constants_1$1.DEFAULT_STATE_SNACKBAR), {}, {
            show: true,
            message: barInfo.snackbar_success
          }));
        }
        trackFollow({
          action: 'do_follow'
        });
        handleCallPostFollow('do_follow');
      }).catch(() => {});
      setFollowState('stop_follow');
      setFollowerQuantity(ctas && ((_ctas$ = ctas[0]) === null || _ctas$ === void 0 || (_ctas$ = _ctas$.success_label) === null || _ctas$ === void 0 ? void 0 : _ctas$.text));
    } else {
      var _tracks$melidata_trac5, _ctas$2;
      deleteFollower({
        baseURL: apiURL,
        ownerId,
        entityId,
        entityType,
        action: actionFollow,
        queryParam: {
          siteId,
          device: deviceType,
          shopType: tracks === null || tracks === void 0 || (_tracks$melidata_trac5 = tracks.melidata_track) === null || _tracks$melidata_trac5 === void 0 || (_tracks$melidata_trac5 = _tracks$melidata_trac5.event_data) === null || _tracks$melidata_trac5 === void 0 ? void 0 : _tracks$melidata_trac5.shop_type,
          ownerId,
          source: client
        }
      });
      setFollowState('do_follow');
      trackFollow({
        action: 'stop_follow'
      });
      setFollowerQuantity(ctas && ((_ctas$2 = ctas[1]) === null || _ctas$2 === void 0 || (_ctas$2 = _ctas$2.success_label) === null || _ctas$2 === void 0 ? void 0 : _ctas$2.text));
      handleCallPostFollow('stop_follow');
    }
  };
  useEffect(() => {
    const actionFollow = getActionFollow();
    if (localStorage.getItem('followLogin')) {
      if (!isDisabled && followState === 'do_follow' && buyerId && localStorage.getItem('followLogin') === (ownerId === null || ownerId === void 0 ? void 0 : ownerId.toString())) {
        var _tracks$melidata_trac6, _tracks$melidata_trac7, _tracks$melidata_trac8, _ctas$3;
        setFollower({
          baseURL: apiURL,
          ownerId,
          entityId,
          entityType,
          withAudience: withCoupon,
          action: actionFollow,
          queryParam: {
            shopType: tracks === null || tracks === void 0 || (_tracks$melidata_trac6 = tracks.melidata_track) === null || _tracks$melidata_trac6 === void 0 || (_tracks$melidata_trac6 = _tracks$melidata_trac6.event_data) === null || _tracks$melidata_trac6 === void 0 ? void 0 : _tracks$melidata_trac6.shop_type,
            device: deviceType,
            source: tracks === null || tracks === void 0 || (_tracks$melidata_trac7 = tracks.melidata_track) === null || _tracks$melidata_trac7 === void 0 || (_tracks$melidata_trac7 = _tracks$melidata_trac7.event_data) === null || _tracks$melidata_trac7 === void 0 ? void 0 : _tracks$melidata_trac7.client,
            ownerId: tracks === null || tracks === void 0 || (_tracks$melidata_trac8 = tracks.melidata_track) === null || _tracks$melidata_trac8 === void 0 || (_tracks$melidata_trac8 = _tracks$melidata_trac8.event_data) === null || _tracks$melidata_trac8 === void 0 ? void 0 : _tracks$melidata_trac8.owner_id,
            siteId
          }
        }).then(() => {
          handleCallPostFollow('do_follow');
        }).catch(() => {});
        setFollowState('stop_follow');
        setFollowerQuantity(ctas && ((_ctas$3 = ctas[0]) === null || _ctas$3 === void 0 || (_ctas$3 = _ctas$3.success_label) === null || _ctas$3 === void 0 ? void 0 : _ctas$3.text));
      }
      localStorage.removeItem('followLogin');
    }
  }, []);
  useEffect(() => {
    if (didMount.current) {
      setDisabledClick(true);
    } else {
      didMount.current = true;
    }
    const timer = setTimeout(() => {
      setDisabledClick(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, [followState]);
  useEffect(() => {
    if (showSnackbar.show === true) {
      const timer = setTimeout(() => {
        setShowSnackbar(constants_1$1.DEFAULT_STATE_SNACKBAR);
      }, constants_1$1.TIMERS.SNACKBAR.MEDIUM);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [showSnackbar]);

  /* is call from modal for coupon in new follower */
  useEffect(() => {
    if (followers !== null && followers !== void 0 && followers.priority_status) {
      setFollowState(followers.priority_status);
    }
  }, [followers === null || followers === void 0 ? void 0 : followers.priority_status]);
  const buttonDisabled = isDisabled || disabledClick;
  const buttonDesktop = () => {
    var _followCta$label;
    return /*#__PURE__*/_jsx(Button, {
      className: `${namespace}__follow-button`,
      hierarchy: "quiet",
      size: "medium",
      onClick: onClickHandler,
      disabled: buttonDisabled
    }, void 0, followCta === null || followCta === void 0 || (_followCta$label = followCta.label) === null || _followCta$label === void 0 ? void 0 : _followCta$label.text, withCoupon && !buttonDisabled && (_Coupon || (_Coupon = /*#__PURE__*/_jsx(Coupon, {}))));
  };
  const fullComponent = () => /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `${namespace}__followers`
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__followers-count`
    }, void 0, followerQuantity), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__followers-button`
    }, void 0, !isMobile && withCoupon ? /*#__PURE__*/_jsx(Tooltip, {
      content: barInfo === null || barInfo === void 0 ? void 0 : barInfo.text,
      side: "topRight"
    }, void 0, buttonDesktop()) : buttonDesktop()))
  });
  const classButtonMobile = classNames(`${namespace}__follow-button--mobile`, {
    [`${namespace}__follow-button--mobile--new`]: withButtonInMobile
  });
  const mobileComponent = () => {
    var _followCta$label2;
    return /*#__PURE__*/jsxs(Fragment, {
      children: [type !== 'SUPER' && type !== 'SUPER_PARTNER' && followerQuantity, /*#__PURE__*/_jsx(Button, {
        className: classButtonMobile,
        hierarchy: withButtonInMobile ? 'quiet' : 'transparent',
        onClick: onClickHandler,
        size: "small",
        disabled: buttonDisabled
      }, void 0, followCta === null || followCta === void 0 || (_followCta$label2 = followCta.label) === null || _followCta$label2 === void 0 ? void 0 : _followCta$label2.text, withCoupon && !buttonDisabled && (_Coupon2 || (_Coupon2 = /*#__PURE__*/_jsx(Coupon, {}))))]
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!isMobile ? fullComponent() : mobileComponent(), /*#__PURE__*/_jsx(Snackbar, {
      color: showSnackbar.color,
      show: showSnackbar.show,
      message: showSnackbar.message
    })]
  });
};
const handleShare = async (isWebview, shareText, shareLink, setShowSnackbar, tracks, shareMedia) => {
  if (tracks) {
    const {
      melidata_track: melidataTrack,
      paths,
      extra_data: extraData
    } = tracks;
    const {
      event_data: data,
      type: trackType
    } = melidataTrack;
    const newData = _objectSpread(_objectSpread({}, data), {}, {
      share_media: shareMedia,
      shop_type: data === null || data === void 0 ? void 0 : data.shop_type.toLowerCase(),
      client: data === null || data === void 0 ? void 0 : data.client.toLowerCase()
    });
    MelidataTrack.sendTrack(paths[MelidataTrack.PATHS.SHARE], newData, trackType, extraData);
  }
  try {
    var _window, _navigator, _navigator2;
    if (isWebview && (_window = window) !== null && _window !== void 0 && (_window = _window.MobileWebKit) !== null && _window !== void 0 && (_window = _window.actions) !== null && _window !== void 0 && _window.share) {
      await window.MobileWebKit.actions.share(shareText, shareLink);
    } else if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.share) {
      await navigator.share({
        text: shareText,
        url: shareLink
      });
    } else if ((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2 = _navigator2.clipboard) !== null && _navigator2 !== void 0 && _navigator2.writeText) {
      await navigator.clipboard.writeText(shareLink);
      setShowSnackbar(true);
    }
  } catch (error) {
    throw new Error(error);
  }
};
const handleTrack = (tracks, shareMedia) => {
  if (tracks) {
    const {
      melidata_track: melidataTrack,
      paths
    } = tracks;
    const {
      event_data: data,
      type: trackType,
      extra_data: extraData
    } = melidataTrack;
    const newData = _objectSpread(_objectSpread({}, data), {}, {
      share_media: shareMedia,
      shop_type: data === null || data === void 0 ? void 0 : data.shop_type.toLowerCase(),
      client: data === null || data === void 0 ? void 0 : data.client.toLowerCase()
    });
    MelidataTrack.sendTrack(paths[MelidataTrack.PATHS.SHARE], newData, trackType, extraData);
  }
};
var _Share$1;
const icons = {
  facebook: FacebookLogo,
  instagram: InstagramLogo,
  whatsapp: WhatsAppLogo,
  x: XLogo,
  mail: Mail20,
  link: Link16
};
const ShareMenu = _ref => {
  let {
    share,
    namespace,
    setShowSnackbar,
    tracks
  } = _ref;
  const {
    text: shareText,
    link: shareLink,
    share_options: shareOptions
  } = share || {};
  const Icon = props => {
    const {
      icon
    } = props;
    const Component = icons[`${icon}`];
    return /*#__PURE__*/jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      width: "20px",
      height: "20px"
    }));
  };
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace}__social-media-container`
  }, void 0, /*#__PURE__*/_jsx(FloatingMenu, {
    id: "floating-menu",
    search: false,
    srLabel: "",
    trigger: shareText && /*#__PURE__*/_jsx("div", {
      target: "_blank",
      rel: "noreferrer",
      className: `${namespace}__share-link`
    }, void 0, _Share$1 || (_Share$1 = /*#__PURE__*/_jsx(Share16, {
      color: constants_1$1.ANDES_BLUE_500
    })), shareText),
    type: "menu",
    width: "184px"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace}__social-media`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace}__social-media-triangle`
  }), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__social-media-icons`
  }, void 0, /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  _jsx("div", {
    className: `${namespace}__share-icon ${namespace}__share-icon--link`,
    role: "button",
    onClick: () => handleShare(false, shareText, shareLink, setShowSnackbar, tracks, 'link'),
    tabIndex: 0
  }, void 0, /*#__PURE__*/_jsx(Icon, {
    icon: "link"
  })), shareOptions === null || shareOptions === void 0 ? void 0 : shareOptions.map(option => /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  _jsx("a", {
    className: `${namespace}__share-icon`,
    href: option.href,
    onClick: () => handleTrack(tracks, option.social_media),
    rel: "noreferrer",
    target: "_blank"
  }, option.social_media, /*#__PURE__*/_jsx(Icon, {
    icon: option.social_media
  })))))));
};
ShareMenu.defaultProps = {
  namespace: 'ui-ms-profile'
};
const useScrollBar = () => {
  const [hasScrollbar, setHasScrollbar] = useState(false);
  const [isEndScrollbar, setIsEndScrollbar] = useState(false);
  const detectScrollbar = (scrollHeight, clientHeight) => {
    setHasScrollbar(scrollHeight > clientHeight);
  };
  const calculateEndScroll = _ref => {
    let {
      scrollTop,
      scrollHeight,
      clientHeight
    } = _ref;
    setIsEndScrollbar(Math.ceil(scrollTop + clientHeight) >= scrollHeight - constants_1$1.BLUR_THRESHOLD);
  };
  return {
    isEndScrollbar,
    calculateEndScroll,
    hasScrollbar,
    detectScrollbar
  };
};
function keyTrap(ev, firstTabStop, lastTabStop) {
  if (ev.keyCode === 9) {
    if (ev.shiftKey) {
      if (document.activeElement === firstTabStop) {
        ev.preventDefault();
        lastTabStop.focus();
      }
    } else if (document.activeElement === lastTabStop) {
      ev.preventDefault();
      firstTabStop.focus();
    }
  }
}
function tabStops(target, className, tagName) {
  if (target) {
    if (className) {
      return [...target.getElementsByClassName(className)];
    }
    if (tagName) {
      return [...target.getElementsByTagName(tagName)];
    }
  }
  return [];
}
function getTargetStops(target, className, tagName) {
  const tabStopsArr = tabStops(target, className, tagName);
  if (tabStopsArr.length > 0) {
    const firstTargetStop = tabStopsArr[0];
    const lastTargetStop = tabStopsArr[tabStopsArr.length - 1];
    return [firstTargetStop, lastTargetStop];
  }
  return [];
}
const handleClickLink = event => {
  window.location.href = event.target.href;
  const urlCurrent = window.location.origin + window.location.pathname;
  if (event.target.href.includes(urlCurrent)) {
    window.location.reload();
  }
};
var _div$2, _div2$1;
const namespace$a = 'ui-ms-profile-drop-down-menu';
const NestedMenu = _ref => {
  let {
    name,
    menuL2,
    viewAll,
    viewAllLink,
    event,
    setEvent,
    setOpenMenu,
    activeClass
  } = _ref;
  const containerRef = useRef(null);
  const selfRef = useRef(null);
  const {
    isEndScrollbar,
    hasScrollbar,
    detectScrollbar,
    calculateEndScroll
  } = useScrollBar();
  const handleScroll = () => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = containerRef.current;
    calculateEndScroll({
      scrollTop,
      scrollHeight,
      clientHeight
    });
  };
  useEffect(() => {
    const container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
    detectScrollbar(container === null || container === void 0 ? void 0 : container.scrollHeight, container === null || container === void 0 ? void 0 : container.clientHeight);
  }, [detectScrollbar]);
  useEffect(() => {
    if (selfRef.current && event !== null) {
      selfRef.current.focus();
      setEvent(null);
    }
  }, [event, setEvent]);
  useEffect(() => {
    const escape = e => {
      if (e.keyCode === 27) {
        e.stopPropagation();
        setOpenMenu(null);
      }
    };
    const node = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
    node === null || node === void 0 || node.addEventListener('keydown', escape);
    return () => {
      node === null || node === void 0 || node.removeEventListener('keydown', escape);
    };
  }, [setOpenMenu]);
  const nestedMenuScrollClassNames = classNames(`${namespace$a}__nested-menu-wrapper`, {
    [`${namespace$a}__nested-menu-scrollbar-width`]: hasScrollbar
  });
  return /*#__PURE__*/jsx("nav", {
    ref: selfRef,
    className: `${namespace$a}__nested-menu`,
    id: "nestedMenu",
    tabIndex: -1,
    "aria-label": name,
    children: /*#__PURE__*/jsxs("div", {
      ref: containerRef,
      role: "group",
      onScroll: handleScroll,
      className: nestedMenuScrollClassNames,
      onKeyDown: e => keyTrap(e, ...getTargetStops(containerRef.current, null, 'a')),
      children: [/*#__PURE__*/_jsx("section", {
        className: `${namespace$a}__nested-menu-view-all`,
        "aria-label": name
      }, void 0, /*#__PURE__*/_jsx("h2", {}, void 0, name), /*#__PURE__*/_jsx("a", {
        href: viewAllLink,
        className: `${namespace$a}__nested-menu-view-all-link`,
        onClick: handleClickLink
      }, void 0, viewAll), _div$2 || (_div$2 = /*#__PURE__*/_jsx("div", {
        className: `${namespace$a}__nested-menu-view-all-line`
      }))), /*#__PURE__*/_jsx("ul", {
        className: `${namespace$a}__nested-menu-items-list`,
        id: `${namespace$a}__nested-menu-items-list`
      }, void 0, menuL2 === null || menuL2 === void 0 ? void 0 : menuL2.map(option => {
        const nestedMenuClasses = classNames(`${namespace$a}__nested-menu-item-link`, {
          [activeClass]: option === null || option === void 0 ? void 0 : option.selected
        });
        return /*#__PURE__*/_jsx("li", {}, option === null || option === void 0 ? void 0 : option.name, /*#__PURE__*/_jsx("a", {
          onClick: handleClickLink,
          href: option === null || option === void 0 ? void 0 : option.url,
          className: nestedMenuClasses
        }, void 0, option === null || option === void 0 ? void 0 : option.name));
      })), hasScrollbar && !isEndScrollbar && (_div2$1 || (_div2$1 = /*#__PURE__*/_jsx("div", {
        className: `${namespace$a}__nested-menu-blur`
      })))]
    })
  });
};
var _div$1, _div2;
const namespace$9 = 'ui-ms-profile-drop-down-menu';
const itemClassName = `${namespace$9}__vertical-menu-item-container-wrapper`;
const DropDownMenu = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    handleOpen,
    menuL1,
    viewAllLabel,
    navigationName
  } = _ref;
  const [menuEvent, setMenuEvent] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const activeMenuClass = `${namespace$9}--active`;
  const {
    isEndScrollbar,
    hasScrollbar,
    detectScrollbar,
    calculateEndScroll
  } = useScrollBar();
  const handleItemHover = index => {
    setOpenMenu(index);
  };
  const handleEnter = (event, index) => {
    var _event$target;
    if ((event === null || event === void 0 ? void 0 : event.key) === 'Enter' && (event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.className) === itemClassName) {
      event.preventDefault();
      setOpenMenu(index);
      setMenuEvent('Enter');
    }
  };
  const handleClick = (event, index) => {
    var _event$target2;
    event.stopPropagation();
    if ((event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.className) === itemClassName) {
      handleItemHover(index);
      setMenuEvent('Click');
    }
  };
  const handleScroll = () => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = ref.current;
    calculateEndScroll({
      scrollTop,
      scrollHeight,
      clientHeight
    });
  };
  useEffect(() => {
    const escape = e => {
      if (e.keyCode === 27) {
        handleOpen(null);
      }
    };
    const node = ref === null || ref === void 0 ? void 0 : ref.current;
    node === null || node === void 0 || node.addEventListener('keydown', escape);
    return () => {
      node === null || node === void 0 || node.removeEventListener('keydown', escape);
    };
  }, [handleOpen, ref]);
  useEffect(() => {
    const container = ref === null || ref === void 0 ? void 0 : ref.current;
    detectScrollbar(container === null || container === void 0 ? void 0 : container.scrollHeight, container === null || container === void 0 ? void 0 : container.clientHeight);
  }, [detectScrollbar, ref]);
  return /*#__PURE__*/jsxs("ul", {
    ref: ref,
    onMouseLeave: () => handleItemHover(),
    className: `${namespace$9}__vertical-menu`,
    id: "verticalMenu",
    onScroll: handleScroll,
    tabIndex: -1,
    role: "dialog",
    "aria-label": navigationName,
    onKeyDown: e => keyTrap(e, ...getTargetStops(ref === null || ref === void 0 ? void 0 : ref.current, itemClassName)),
    children: [menuL1.map((menuItem, index) => {
      var _menuItem$picture;
      const verticalMenuClasses = classNames(`${namespace$9}__vertical-menu-item-container`, {
        [activeMenuClass]: menuItem === null || menuItem === void 0 ? void 0 : menuItem.selected
      });
      return /*#__PURE__*/_jsx("li", {
        className: verticalMenuClasses,
        id: `${namespace$9}__vertical-menu-item-container`
      }, menuItem === null || menuItem === void 0 ? void 0 : menuItem.name, /*#__PURE__*/_jsx("div", {
        role: "button",
        "aria-expanded": openMenu === index,
        tabIndex: 0,
        className: itemClassName,
        onClick: e => handleClick(e, index),
        onMouseEnter: () => handleItemHover(index),
        onKeyDown: e => handleEnter(e, index)
      }, void 0, /*#__PURE__*/_jsx("section", {
        className: `${namespace$9}__vertical-menu-item`
      }, void 0, /*#__PURE__*/_jsx(Image, {
        src: menuItem === null || menuItem === void 0 || (_menuItem$picture = menuItem.picture) === null || _menuItem$picture === void 0 ? void 0 : _menuItem$picture.url,
        className: `${namespace$9}__vertical-menu-item-image`,
        lazyload: "off"
      }), /*#__PURE__*/_jsx("a", {
        onClick: handleClickLink,
        href: menuItem === null || menuItem === void 0 ? void 0 : menuItem.url,
        tabIndex: -1,
        className: `${namespace$9}__vertical-menu-item-link`
      }, void 0, menuItem === null || menuItem === void 0 ? void 0 : menuItem.name)), _div$1 || (_div$1 = /*#__PURE__*/_jsx("div", {
        className: `${namespace$9}__vertical-menu-item--chevron`,
        role: "button",
        name: "chevron-btn"
      }, void 0, /*#__PURE__*/_jsx(ChevronRight20, {})))), openMenu === index && /*#__PURE__*/_jsx(NestedMenu, {
        name: menuItem === null || menuItem === void 0 ? void 0 : menuItem.name,
        menuL2: menuItem === null || menuItem === void 0 ? void 0 : menuItem.nodes,
        viewAll: viewAllLabel,
        viewAllLink: menuItem === null || menuItem === void 0 ? void 0 : menuItem.url,
        event: menuEvent,
        setEvent: setMenuEvent,
        setOpenMenu: setOpenMenu,
        activeClass: activeMenuClass
      }));
    }), hasScrollbar && !isEndScrollbar && (_div2 || (_div2 = /*#__PURE__*/_jsx("div", {
      className: `${namespace$9}__vertical-menu-blur`
    })))]
  });
});
var _ChevronDown$1, _ChevronUp;
const DynamicMenu = _ref => {
  let {
    name,
    nodes: menuL1,
    namespace,
    handleOpen,
    isOpen,
    viewAllLabel,
    withSeparator
  } = _ref;
  const dropDownMenuRef = useRef(null);
  const handleEnter = event => {
    event.stopPropagation();
    if ((event === null || event === void 0 ? void 0 : event.key) === 'Enter') {
      handleOpen(name);
    }
  };
  const handleClick = event => {
    handleOpen(name);
    if (event.target.classList.contains(`${namespace}__dynamic-hover-menu`)) {
      setTimeout(() => {
        dropDownMenuRef.current.focus();
      }, 10);
    }
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: `${namespace}__dynamic-hover-menu`,
      role: "button",
      onMouseEnter: () => handleOpen(name),
      onClick: e => handleClick(e),
      onKeyDown: e => handleEnter(e),
      tabIndex: 0
    }, void 0, /*#__PURE__*/_jsx(FloatingMenu$1, {
      className: `${namespace}__dynamic-floating-menu`,
      trigger: /*#__PURE__*/_jsx("li", {
        className: `${namespace}__item`
      }, void 0, name, isOpen !== name ? _ChevronDown$1 || (_ChevronDown$1 = /*#__PURE__*/_jsx(ChevronDown12, {})) : _ChevronUp || (_ChevronUp = /*#__PURE__*/_jsx(ChevronUp12, {}))),
      width: "100%",
      tabIndex: 0,
      open: isOpen === name
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__dynamic-floating-menu-triangle`
    }), /*#__PURE__*/jsx(DropDownMenu, {
      handleOpen: handleOpen,
      ref: dropDownMenuRef,
      menuL1: menuL1,
      viewAllLabel: viewAllLabel,
      navigationName: name
    }))), withSeparator && /*#__PURE__*/_jsx("div", {
      className: `${namespace}__dynamic-menu-separator`
    })]
  });
};
const getSelectedSubNodes = function () {
  var _node$nodes, _node$nodes$some;
  let node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const isSelectedSubNode = node === null || node === void 0 || (_node$nodes = node.nodes) === null || _node$nodes === void 0 || (_node$nodes$some = _node$nodes.some) === null || _node$nodes$some === void 0 ? void 0 : _node$nodes$some.call(_node$nodes, function () {
    let {
      selected,
      nodes
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return selected || nodes && nodes.length && getSelectedSubNodes({
      nodes
    });
  });
  return isSelectedSubNode;
};
const renderOldMenu = (moreSectionsOption, menuL1, maxNodesInLine) => {
  const newMenuL1 = menuL1.filter(item => {
    var _item$nodes;
    return !((item === null || item === void 0 ? void 0 : item.type) === constants_1$1.TYPES_ITEM.FOLDER && !(item !== null && item !== void 0 && (_item$nodes = item.nodes) !== null && _item$nodes !== void 0 && _item$nodes.length));
  }).filter(item => item === null || item === void 0 ? void 0 : item.in_header);
  let menuOptions = newMenuL1;
  let menuAllProducts = null;
  if (newMenuL1 && newMenuL1.length > 3) {
    menuAllProducts = newMenuL1 === null || newMenuL1 === void 0 ? void 0 : newMenuL1.find(item => (item === null || item === void 0 ? void 0 : item.id) === 'all-products');
    newMenuL1.forEach((props, index) => {
      if (index >= maxNodesInLine && (props === null || props === void 0 ? void 0 : props.id) !== 'all-products') {
        moreSectionsOption.nodes.push(props);
      }
    });
    if (moreSectionsOption.nodes.length >= 2) {
      const newMenu = newMenuL1.slice(0, maxNodesInLine);
      newMenu.push(moreSectionsOption);
      menuOptions = newMenu;
    }
  }
  if (menuAllProducts) {
    menuOptions = menuOptions.filter(item => (item === null || item === void 0 ? void 0 : item.id) !== 'all-products');
    menuOptions.push(menuAllProducts);
  }
  return menuOptions;
};
const renderCorridorsMenu = (moreSectionsOption, menuL1) => {
  const menuOptions = [];
  if (!menuL1 || menuL1.length === 0) {
    return null;
  }
  menuL1.forEach((item, index) => {
    const isLastItem = index === menuL1.length - 1;
    const isHeader = item === null || item === void 0 ? void 0 : item.in_header;
    if (!isHeader) {
      var _menuL;
      moreSectionsOption.nodes.push(item);
      if (isLastItem || (_menuL = menuL1[index + 1]) !== null && _menuL !== void 0 && _menuL.in_header) {
        menuOptions.push(_objectSpread({}, moreSectionsOption));
      }
    } else {
      menuOptions.push(item);
    }
  });
  return menuOptions;
};
const getMenuProps = _ref => {
  let {
    menuL1,
    categoriesLabel,
    categoriesSelected,
    maxNodesInLine,
    menuType
  } = _ref;
  const moreSectionsOption = {
    id: '',
    name: categoriesLabel,
    url: '/#',
    nodes: [],
    selected: categoriesSelected
  };
  if ((menuType === null || menuType === void 0 ? void 0 : menuType.toUpperCase()) === constants_1$1.MENU_TYPE.CORRIDORS) {
    return renderCorridorsMenu(moreSectionsOption, menuL1);
  }
  return renderOldMenu(moreSectionsOption, menuL1, maxNodesInLine);
};
const isCCP = function () {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return id === null || id === void 0 ? void 0 : id.includes('custom_content_page');
};
var _ChevronDown, _Fragment$1, _Fragment3, _Fragment4, _ChevronRight$1, _Fragment5, _ChevronRight2, _Fragment6;
const NAVIGATION_SIMPLE_ID = 'navigation-bar-section-simple';
const shareTypes$1 = [constants_1$1.TYPES.SELLER, constants_1$1.TYPES.BRAND, constants_1$1.TYPES.LANDING];
const NavigationBar = _ref => {
  var _span, _span2;
  let {
    namespace,
    menuL1,
    menuType,
    categoriesLabel,
    viewAllLabel,
    followers,
    isMobile,
    ownerId,
    buyerId,
    baseURL,
    maxNodesInLine,
    siteId,
    categoriesSelected,
    type,
    tracks,
    share,
    setShowSnackbar,
    withSeparator,
    isHiddenNodeHeader,
    isEditable,
    isOpenOverlay,
    limitL2,
    barInfo,
    deviceType,
    handlePostFollow,
    flowSource,
    trackingData
  } = _ref;
  const ref = useRef();
  const [isOpen, setIsOpen] = useState(() => {
    if (isEditable && isOpenOverlay) {
      return categoriesLabel;
    }
    return null;
  });
  const overlayRef = useRef(null);
  const isSelectedSubNodeRef = useRef(false);
  const {
    unsubscribe,
    subscribe
  } = useMessage();
  const validTrack = trackingData || {
    ownerId,
    type
  };
  const {
    trackingId
  } = trackingData;
  const classActive = selected => `${namespace}${selected ? '__active' : '__inactive'}`;
  const itemActive = active => `${namespace}${active ? '__active-item' : '__inactive-item'}`;
  const handleOpen = id => {
    setIsOpen(id);
  };
  const handleCloseMenuExpanded = () => {
    setIsOpen(isEditable ? categoriesLabel : null);
  };
  const subscribeToMenuActions = (messageGroup, action, payload) => {
    if (messageGroup !== 'menu-panel' || action !== 'toggleSubMenu') return;
    const {
      isOpen: isOpenEvent,
      item
    } = payload;
    if (isOpenEvent === false) {
      handleCloseMenuExpanded();
    } else {
      handleOpen((item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.name));
    }
  };
  const addTrackUrl = baseUrl => {
    const encodedPlaceholder = '%7Btracking_id%7D';
    const encodedTrackingId = encodeURIComponent(trackingId !== null && trackingId !== void 0 ? trackingId : '');
    return baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.replace(encodedPlaceholder, encodedTrackingId);
  };
  useEffect(() => {
    if (!isEditable) {
      return () => {};
    }
    subscribe(subscribeToMenuActions);
    return unsubscribe;
  }, []);
  useEffect(() => {
    if (isOpen) {
      MelidataTrack.menuView(validTrack);
    }
  }, [isOpen, type, ownerId, buyerId]);
  const SectionMultiple = _ref2 => {
    var _nodesL2$some;
    let {
      name,
      nodes: nodesL2,
      selected,
      id: idL1
    } = _ref2;
    let openDefault = null;
    if (isEditable && name === categoriesLabel && nodesL2 !== null && nodesL2 !== void 0 && (_nodesL2$some = nodesL2.some) !== null && _nodesL2$some !== void 0 && _nodesL2$some.call(nodesL2, node => (node === null || node === void 0 ? void 0 : node.id) === isOpen)) {
      openDefault = categoriesLabel;
    }
    if (selected === true) {
      isSelectedSubNodeRef.current = idL1;
    }
    let isSelectedSubNode = selected || isSelectedSubNodeRef.current !== '' && isSelectedSubNodeRef.current === idL1;
    if (isHiddenNodeHeader && isSelectedSubNodeRef.current === false) {
      isSelectedSubNode = getSelectedSubNodes({
        nodes: nodesL2
      });
      if (isSelectedSubNode) isSelectedSubNodeRef.current = idL1;
    }
    return /*#__PURE__*/jsx("div", {
      className: `${namespace}__hover-menu`,
      onMouseEnter: () => handleOpen(idL1 || name),
      ref: ref,
      children: /*#__PURE__*/_jsx(FloatingMenu, {
        className: `${namespace}__floating-menu`,
        trigger: /*#__PURE__*/_jsx("li", {
          className: `${namespace}__item ${classActive(isSelectedSubNode)}`
        }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, name), _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx(ChevronDown12, {}))),
        width: "100%",
        open: openDefault || isOpen === idL1 || isOpen === name
      }, void 0, nodesL2.map(_ref3 => {
        let {
          name: nameL2,
          url: urlL2,
          nodes: nodesL3Props,
          in_header: inHeader,
          id: idL2,
          hidden: hiddenL2,
          type: typeL2
        } = _ref3;
        const isFolder = typeL2 === constants_1$1.TYPES_ITEM.FOLDER;
        const isFolderREmpty = isFolder && !(nodesL3Props !== null && nodesL3Props !== void 0 && nodesL3Props.length);
        if (isHiddenNodeHeader && inHeader === false && isCCP(idL2) || isEditable && hiddenL2 === true || isFolderREmpty) {
          return _Fragment$1 || (_Fragment$1 = /*#__PURE__*/jsx(Fragment, {}));
        }
        let nodesL3 = nodesL3Props;
        if (limitL2) {
          var _nodesL;
          const limit = isMobile ? limitL2 === null || limitL2 === void 0 ? void 0 : limitL2.mobile : limitL2 === null || limitL2 === void 0 ? void 0 : limitL2.desktop;
          if (((_nodesL = nodesL3) === null || _nodesL === void 0 ? void 0 : _nodesL.length) > limit) {
            nodesL3 = nodesL3.slice(0, limit);
          }
        }
        return /*#__PURE__*/_jsx(FloatingMenuGroup, {
          label: nameL2,
          className: `${namespace}__floating-menu-group`
        }, void 0, nodesL3 && nodesL3.map(_ref4 => {
          let {
            name: nameL3,
            url: urlL3,
            selected: active,
            in_header: inHeaderL3,
            id: idL3,
            hidden: hiddenL3
          } = _ref4;
          const notInHeaderL3 = inHeaderL3 === false;
          const ccpHiddenAndNotInHeader = isHiddenNodeHeader && notInHeaderL3 && isCCP(idL3);
          const hiddenAndEditable = isEditable && hiddenL3 === true;
          if (ccpHiddenAndNotInHeader || hiddenAndEditable) {
            return _Fragment3 || (_Fragment3 = /*#__PURE__*/jsx(Fragment, {}));
          }
          if (isEditable) {
            return /*#__PURE__*/_jsx("span", {
              className: "andes-list__item-primary"
            }, void 0, nameL3);
          }
          return /*#__PURE__*/_jsx(FloatingMenuItem, {
            title: nameL3,
            href: addTrackUrl(urlL3),
            className: `${namespace}__floating-menu-item ${itemActive(active)}`
          });
        }), isFolder ? _Fragment4 || (_Fragment4 = /*#__PURE__*/jsx(Fragment, {})) : /*#__PURE__*/jsxs(Fragment, {
          children: [isEditable ? /*#__PURE__*/_jsx(FloatingMenuItem, {
            title: _span || (_span = /*#__PURE__*/_jsx("span", {}, void 0, viewAllLabel, _ChevronRight$1 || (_ChevronRight$1 = /*#__PURE__*/_jsx(ChevronRight12, {})))),
            href: addTrackUrl(urlL2),
            className: `${namespace}__floating-menu-link--hidden`
          }) : _Fragment5 || (_Fragment5 = /*#__PURE__*/jsx(Fragment, {})), /*#__PURE__*/_jsx(FloatingMenuItem, {
            title: _span2 || (_span2 = /*#__PURE__*/_jsx("span", {}, void 0, viewAllLabel, _ChevronRight2 || (_ChevronRight2 = /*#__PURE__*/_jsx(ChevronRight12, {})))),
            href: addTrackUrl(urlL2),
            className: `${namespace}__floating-menu-link`
          })]
        }));
      }))
    });
  };
  const SectionSimple = _ref5 => {
    let {
      name: nameL1,
      url: urlL1,
      selected,
      with_separator: withNodeSeparator = false
    } = _ref5;
    return /*#__PURE__*/jsxs(Fragment, {
      children: [withNodeSeparator && /*#__PURE__*/_jsx("div", {
        className: `${namespace}__menu-separator`
      }), /*#__PURE__*/_jsx("div", {
        className: classActive(selected)
      }, nameL1, /*#__PURE__*/_jsx("a", {
        href: addTrackUrl(urlL1),
        className: `${namespace}__item ${namespace}__menu-element`,
        id: NAVIGATION_SIMPLE_ID,
        onMouseEnter: handleCloseMenuExpanded
      }, void 0, nameL1))]
    });
  };
  const menuOptions = getMenuProps({
    menuL1,
    categoriesLabel,
    categoriesSelected,
    maxNodesInLine,
    menuType
  });
  const renderMenuItem = props => {
    switch (menuType) {
      case constants_1$1.MENU_TYPE.CORRIDORS:
        if (!(props !== null && props !== void 0 && props.in_header)) {
          return /*#__PURE__*/jsx(DynamicMenu, _objectSpread(_objectSpread({}, props), {}, {
            isOpen: isOpen,
            handleOpen: handleOpen,
            classActive: classActive,
            namespace: namespace,
            viewAllLabel: viewAllLabel,
            withSeparator: withSeparator
          }));
        }
        return /*#__PURE__*/jsx(SectionSimple, _objectSpread({}, props));
      default:
        {
          var _props$nodes, _props$nodes2;
          const isFolderEmpty = (props === null || props === void 0 ? void 0 : props.type) === constants_1$1.TYPES_ITEM.FOLDER && !(props !== null && props !== void 0 && (_props$nodes = props.nodes) !== null && _props$nodes !== void 0 && _props$nodes.length);
          const notInHeader = (props === null || props === void 0 ? void 0 : props.in_header) === false;
          const ccpNotInHeader = isHiddenNodeHeader && notInHeader && isCCP(props === null || props === void 0 ? void 0 : props.id);
          const hidden = props.hidden === true;
          const editableAndHidden = isEditable && hidden;
          if (ccpNotInHeader || editableAndHidden || isFolderEmpty) {
            return _Fragment6 || (_Fragment6 = /*#__PURE__*/jsx(Fragment, {}));
          }
          const nodesQuantity = (props === null || props === void 0 || (_props$nodes2 = props.nodes) === null || _props$nodes2 === void 0 ? void 0 : _props$nodes2.length) > 0;
          return nodesQuantity ? /*#__PURE__*/jsx(SectionMultiple, _objectSpread({}, props)) : /*#__PURE__*/jsx(SectionSimple, _objectSpread({}, props));
        }
    }
  };
  const CorridorsMenuClassNames = classNames(`${namespace}__navigation-container`, {
    [`${namespace}__corridors-navigation-container`]: constants_1$1.MENU_TYPE.CORRIDORS === menuType
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      onMouseLeave: handleCloseMenuExpanded,
      className: CorridorsMenuClassNames
    }, void 0, menuOptions && /*#__PURE__*/_jsx("div", {
      className: `${namespace}__navigation`,
      "data-testid": "affiliate-navbar"
    }, void 0, /*#__PURE__*/_jsx("ul", {
      className: `${namespace}__list`
    }, void 0, menuOptions.map(props => renderMenuItem(props)))), !isMobile && /*#__PURE__*/_jsx("div", {
      className: `${namespace}__close-floating-menu`,
      onMouseEnter: handleCloseMenuExpanded
    }), !isMobile && followers && /*#__PURE__*/_jsx(Followers, {
      followers: followers,
      namespace: namespace,
      isMobile: isMobile,
      ownerId: ownerId,
      buyerId: buyerId,
      baseURL: baseURL,
      siteId: siteId,
      tracks: tracks,
      barInfo: barInfo,
      deviceType: deviceType,
      handlePostFollow: handlePostFollow,
      flowSource: flowSource
    }), !isMobile && shareTypes$1.includes(type === null || type === void 0 ? void 0 : type.toLowerCase()) && share && /*#__PURE__*/_jsx(ShareMenu, {
      share: share,
      namespace: namespace,
      setShowSnackbar: setShowSnackbar,
      tracks: tracks
    })), /*#__PURE__*/jsx("div", {
      ref: overlayRef,
      className: isOpenOverlay || isOpen !== null ? 'floating-menu-overlay--open' : 'floating-menu-overlay--close',
      "data-testid": "floating-menu-overlay"
    })]
  });
};
NavigationBar.defaultProps = {
  namespace: 'ui-ms-profile',
  categoriesLabel: 'Todas las categorías',
  viewAllLabel: 'Ver todo',
  followers: {
    cta_status: null,
    ctas: [],
    text: 'Seguidores'
  },
  maxNodesInLine: 2,
  categoriesSelected: false,
  share: null,
  isHiddenNodeHeader: false,
  limitL2: null
};
const namespace$8 = 'ui-ms-styled-label';
const getStyledLabelClass = function () {
  let {
    color,
    size,
    weight
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const classes = [];
  if (color) {
    classes.push(`${namespace$8}__color--${color.toLowerCase()}`);
  }
  if (size) {
    classes.push(`${namespace$8}__size--${size.toLowerCase()}`);
  }
  if (weight) {
    classes.push(`${namespace$8}__weight--${weight.toLowerCase()}`);
  }
  if (classes.length < 1) {
    return '';
  }
  classes.push(namespace$8);
  return classNames(...classes);
};
const hasLongWord = userName => {
  const words = userName.split(' ');

  // eslint-disable-next-line no-restricted-syntax
  for (const word of words) {
    if (word.length >= 20) {
      return true;
    }
  }
  return false;
};
const Affiliate = 'AFFILIATE';
const Seller = 'SELLER';
const Social = 'SOCIAL';
const Super = 'SUPER';
const SuperPartner = 'SUPER_PARTNER';
const Landing = 'LANDING';
var storefrontType = {
  Affiliate,
  Seller,
  Social,
  Super,
  SuperPartner,
  Landing
};
var _VerifiedLogo;
const Labels = _ref => {
  let {
    namespace,
    id,
    icon,
    label,
    followers,
    isMobile,
    ownerId,
    buyerId,
    baseURL,
    type,
    siteId,
    tracks,
    barInfo,
    deviceType,
    handlePostFollow = () => {},
    theme,
    flowSource
  } = _ref;
  const {
    LANDING_CBT
  } = constants_1$1.THEMES;
  const {
    label_id: labelId
  } = followers || {};
  const {
    color,
    font_size: size,
    font_weight: weight,
    text
  } = label || {};
  const styledLabelClasses = getStyledLabelClass({
    color,
    size,
    weight
  });
  const labelClass = classNames(`${namespace}__${id}`, styledLabelClasses, {
    [`${namespace}__${id}--long`]: id === 'full_name' && hasLongWord(text),
    'ui-ms-styled-label--default': !styledLabelClasses && type !== storefrontType.Landing,
    [`${namespace}__sub-title`]: type === 'SUPER' || type === 'SUPER_PARTNER',
    'ui-ms-profile-landing': type === storefrontType.Landing
  });
  const renderText = () => {
    if (typeof text === 'string' && text.startsWith('http')) {
      return /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/_jsx(Image$1, {
          src: text,
          alt: "label header eshops",
          className: `${namespace}__logo-home`
        })
      });
    }
    return id === 'sub_description' && !styledLabelClasses ? '' : text;
  };
  const isLandingCBT = theme === LANDING_CBT;
  return text && /*#__PURE__*/jsxs(Fragment, {
    children: [!isLandingCBT ? /*#__PURE__*/_jsx("p", {
      className: labelClass
    }, void 0, icon && (_VerifiedLogo || (_VerifiedLogo = /*#__PURE__*/_jsx(VerifiedLogo, {}))), renderText()) : /*#__PURE__*/_jsx("h1", {
      className: labelClass
    }, void 0, renderText()), id === labelId && /*#__PURE__*/_jsx("p", {
      className: labelClass
    }, void 0, /*#__PURE__*/_jsx(Followers, {
      followers: followers,
      namespace: namespace,
      isMobile: isMobile,
      ownerId: ownerId,
      buyerId: buyerId,
      baseURL: baseURL,
      type: type,
      siteId: siteId,
      tracks: tracks,
      barInfo: barInfo,
      deviceType: deviceType,
      handlePostFollow: handlePostFollow,
      flowSource: flowSource
    }))]
  });
};
Labels.defaultProps = {
  namespace: 'ui-ms-profile'
};
const shareUrl = (isWebview, browserUrl, text, setShowSnackbar) => {
  if (isWebview) {
    var _window, _window2;
    const shareHref = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href;
    const keepRefParamOnly = url => {
      const urlObject = new URL(url);
      const {
        searchParams
      } = urlObject;
      const keysToRemove = Array.from(searchParams.keys()).filter(key => key !== 'ref' && key !== 'matt_tool' && key !== 'forceInApp');
      keysToRemove.forEach(keyToRemove => searchParams.delete(keyToRemove));
      return urlObject.toString();
    };
    const updatedURL = keepRefParamOnly(shareHref);
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.MobileWebKit) === null || _window2 === void 0 || (_window2 = _window2.actions) === null || _window2 === void 0 || _window2.share(text, updatedURL).catch(() => {
      var _navigator;
      (_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.clipboard) === null || _navigator === void 0 || _navigator.writeText(updatedURL);
      setShowSnackbar(true);
    });
  } else {
    var _navigator2;
    (_navigator2 = navigator) === null || _navigator2 === void 0 || (_navigator2 = _navigator2.clipboard) === null || _navigator2 === void 0 || _navigator2.writeText(browserUrl);
    setShowSnackbar(true);
  }
};
var _Button;
const OptionsMenu = _ref => {
  var _global;
  let {
    namespace,
    optionsMenu,
    isWebview,
    type
  } = _ref;
  const {
    nodes
  } = optionsMenu || {};
  const browserUrl = (_global = global) === null || _global === void 0 || (_global = _global.location) === null || _global === void 0 ? void 0 : _global.href;
  let snackbarMessage = '';
  const [showSnackbar, setShowSnackbar] = useState(false);
  nodes === null || nodes === void 0 || nodes.forEach(node => {
    // TODO: should use a valid id
    if (node.text === 'Compartir' || node.text === 'Compartilhar') {
      node.onClick = () => shareUrl(isWebview, browserUrl, node.text, setShowSnackbar);
      snackbarMessage = node.snackbar_success_text;
    }
  });
  useEffect(() => {
    if (showSnackbar) {
      setTimeout(() => {
        setShowSnackbar(false);
      }, 5000);
    }
  }, [showSnackbar]);
  const isValid = () => typeof window !== 'undefined' && typeof window.document !== 'undefined' && window.document.body !== null;
  const floatingMenuClass = classNames(`${namespace}__options-menu`, {
    [`${namespace}__affiliates-menu--dropdown`]: type === 'AFFILIATES'
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingMenu$1, {
      id: "floating-menu",
      className: floatingMenuClass,
      trigger: _Button || (_Button = /*#__PURE__*/_jsx(Button$1, {}, void 0, /*#__PURE__*/_jsx(OverflowMenuVertical16, {}))),
      srLabel: "",
      width: "128px"
    }, void 0, nodes.map((_ref2, index) => {
      let {
        text,
        url,
        onClick
      } = _ref2;
      const menuProps = {
        title: text,
        value: index
      };
      menuProps.href = url;
      if (onClick) {
        menuProps.onClick = onClick;
      } else {
        menuProps.target = '_blank';
      }
      return /*#__PURE__*/jsx(FloatingMenuItem, _objectSpread({}, menuProps));
    })), isValid() && /*#__PURE__*/_jsx(Snackbar$1, {
      color: "green",
      delay: 5000,
      message: snackbarMessage,
      show: showSnackbar
    })]
  });
};
OptionsMenu.defaultProps = {
  namespace: 'ui-ms-profile'
};
var _circle;
const UserCircle = _ref => {
  let {
    className,
    width,
    height,
    color,
    fillOpacity,
    circleColor,
    strokeOpacity,
    strokeWidth
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: `0 0 ${width} ${height}`,
    fill: "none",
    className: className
  }, void 0, _circle || (_circle = /*#__PURE__*/_jsx("circle", {
    cx: "28",
    cy: "28",
    r: "28",
    fill: "white"
  })), /*#__PURE__*/_jsx("circle", {
    cx: "28",
    cy: "28",
    r: "27.75",
    stroke: circleColor,
    strokeOpacity: strokeOpacity,
    strokeWidth: strokeWidth
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: 'M28.0144 29.6959C32.6891 29.6959 36.4787 25.9063 36.4787 21.2316C36.4787 16.5569 32.6891 12.7673 28.0144 12' + '.7673C23.3397 12.7673 19.5501 16.5569 19.5501 21.2316C19.5501 25.9063 23.3397 29.6959 28.0144 29.6959ZM28.' + '0144 26.3107C25.2093 26.3107 22.9353 24.0367 22.9353 21.2316C22.9353 18.4266 25.2093 16.1526 28.0144 16.15' + '26C30.8195 16.1526 33.0934 18.4266 33.0934 21.2316C33.0934 24.0367 30.8195 26.3107 28.0144 26.3107Z',
    fill: color,
    fillOpacity: fillOpacity
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: 'M50 28C50 40.1503 40.1503 50 28 50C15.8497 50 6 40.1503 6 28C6 15.8497 15.8497 6 28 6C40.1503 6 50 15.8497 ' + '50 28ZM16.1361 42.3448C19.3571 45.0118 23.4914 46.6147 28 46.6147C32.5073 46.6147 36.6404 45.0128 39.8611 ' + '42.3472V41.541C39.8611 38.7369 37.588 36.4638 34.784 36.4638H21.1691C18.3894 36.4638 16.1361 38.7172 16.13' + '61 41.4968V42.3448ZM13.0852 39.1399C10.7614 36.0338 9.38527 32.1776 9.38527 28C9.38527 17.7194 17.7194 9.3' + '8527 28 9.38527C38.2806 9.38527 46.6147 17.7194 46.6147 28C46.6147 32.1836 45.2346 36.0448 42.9048 39.1532' + 'C41.8742 35.6422 38.6285 33.0786 34.784 33.0786H21.1691C17.3379 33.0786 14.1045 35.6378 13.0852 39.1399Z',
    fill: color,
    fillOpacity: fillOpacity
  }));
};
UserCircle.defaultProps = {
  className: '',
  width: '56',
  height: '56',
  color: 'black',
  circleColor: 'black',
  fillOpacity: '0.55',
  strokeOpacity: '0.25',
  strokeWidth: '0.5'
};
const PICTURE_API_VARIATIONS = {
  1920: 'OO',
  1200: 'F',
  800: 'B',
  500: 'O',
  400: 'C',
  320: 'V',
  280: 'E',
  250: 'P',
  228: 'A',
  210: 'Y',
  200: 'N',
  160: 'T',
  120: 'G',
  90: 'I',
  70: 'R',
  40: 'M'
};
const MAX_SIZE_BY_DEVICE = {
  BANNER: {
    DESKTOP_LARGE: 1920,
    DESKTOP: 1200,
    MOBILE: 720
  },
  LOGO: {
    CIRCLE: {
      DESKTOP: 120,
      MOBILE: 120
    },
    DEFAULT: {
      DESKTOP: 120,
      MOBILE: 120
    }
  }
};
const getPicturesApiVariation = (requiredSize, imageUrl) => {
  if (!imageUrl) {
    return imageUrl;
  }
  // eslint-disable-next-line max-len
  const picturesApiUrl = /(https:\/\/http2\.mlstatic\.com\/(?:D_||N?Q_|N?P_)*\d+-(MLA|MLM|MLB|MCO|MLC)\d+_\d+)-[A-Z]+\.(?:webp|jpg|png)/;
  const match = imageUrl.match(picturesApiUrl);
  if (match) {
    const sizes = Object.keys(PICTURE_API_VARIATIONS).map(Number).sort((a, b) => a - b);
    const closestSize = sizes.find(size => size >= requiredSize) || sizes[sizes.length - 1];
    // eslint-disable-next-line security/detect-object-injection
    return `${match[1]}-${PICTURE_API_VARIATIONS[closestSize]}.webp`;
  }
  return imageUrl;
};
const getBannerImageVariation = (isMobile, imageUrl, width) => {
  const desktopSize = width > 1200 ? MAX_SIZE_BY_DEVICE.BANNER.DESKTOP_LARGE : MAX_SIZE_BY_DEVICE.BANNER.DESKTOP;
  const requiredSize = isMobile ? MAX_SIZE_BY_DEVICE.BANNER.MOBILE : desktopSize;
  return getPicturesApiVariation(requiredSize, imageUrl);
};
const getLogoImageVariation = (isMobile, imageUrl, imageType) => {
  const requiredSizeByDevice = MAX_SIZE_BY_DEVICE.LOGO[imageType] || MAX_SIZE_BY_DEVICE.LOGO.DEFAULT;
  const requiredSize = isMobile ? requiredSizeByDevice.MOBILE : requiredSizeByDevice.DESKTOP;
  return getPicturesApiVariation(requiredSize, imageUrl);
};
var _UserCircle;
const UserImage = _ref => {
  let {
    namespace,
    type,
    image,
    nameEshop = '',
    isMobile
  } = _ref;
  const {
    url: imageUrl,
    image_type: imageType
  } = image || {};
  const isAffiliate = type.toUpperCase() === storefrontType.Affiliate;
  const imageTitle = nameEshop ? `Logo ${nameEshop}` : '';
  const logoImageUrl = getLogoImageVariation(isMobile, imageUrl, imageType);
  return isAffiliate && !imageUrl ? _UserCircle || (_UserCircle = /*#__PURE__*/_jsx(UserCircle, {})) : /*#__PURE__*/_jsx(Image$1, {
    className: `${namespace}__${imageType === null || imageType === void 0 ? void 0 : imageType.toLowerCase()}`,
    src: logoImageUrl,
    title: imageTitle
  });
};
const redirectDefault = (url, isWebview) => {
  if (isWebview) {
    window.MobileWebKit.navigation.push(url).catch(() => {
      window.location = url;
    });
  } else {
    window.location = url;
  }
};
const redirectEvent = async (url, isWebview, behavior, hasCalledNativeBottomSheet, openBottomSheet) => {
  if (isWebview) {
    if (constants_1$1.BEHAVIOR_TYPE.BOTTOM_SHEET === behavior) {
      if (window.MobileWebKit.platform === 'ios') {
        window.MobileWebKit.executeNative({
          method: 'wk_present',
          args: {
            deeplink: url,
            animated: true,
            over_context: false
          }
        });
      } else if (!hasCalledNativeBottomSheet.current) {
        await window.MobileWebKit.navigation.push(url);
        hasCalledNativeBottomSheet.current = true;
      }
    } else {
      window.MobileWebKit.navigation.push(url).catch(() => {
        window.location = url;
      });
    }
  } else if (constants_1$1.BEHAVIOR_TYPE.BOTTOM_SHEET === behavior) {
    openBottomSheet();
  } else {
    window.location = url;
  }
};
var _Share;
const shareTypes = [constants_1$1.TYPES.SELLER, constants_1$1.TYPES.BRAND];
const Banner = _ref => {
  var _Followers, _Menu;
  let {
    banner,
    baseURL,
    buyerId,
    children,
    followers,
    image,
    isMobile,
    labels,
    namespace,
    optionsMenu,
    ownerId,
    socialProfileType,
    superProfileType,
    type,
    siteId,
    tracks,
    isWebview,
    share,
    setShowSnackbar,
    deviceType,
    handlePostFollow,
    theme,
    flowSource
  } = _ref;
  const {
    target: homeUrl,
    hidden = false
  } = image || {};
  const {
    url: bannerUrl,
    url_mobile: urlBannerMobile,
    banner_mobile_id: bannerMobileId
  } = banner || {};
  const {
    text: shareText,
    link: shareLink
  } = share || {};
  const [windowWidth, setWindowWidth] = useState(null);
  const bannerClassnames = classNames(`${namespace}__banner`, {
    'banner--social': socialProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase()),
    [`${namespace}__banner--white`]: !bannerUrl
  });
  const bannerImageClassnames = classNames(`${namespace}__banner`, {
    [`${namespace}__banner--empty`]: !bannerUrl
  });
  const isAffiliate = type.toUpperCase() === storefrontType.Affiliate;
  const isLanding = type.toUpperCase() === storefrontType.Landing;
  const isSocial = type.toUpperCase() === storefrontType.Social;
  const isNotClickable = isAffiliate || isSocial;
  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);
  const bannerImage = getBannerImageVariation(isMobile, bannerUrl, windowWidth);
  const bannerMobileImage = bannerMobileId && urlBannerMobile ? getBannerImageVariation(isMobile, urlBannerMobile, windowWidth) : bannerImage;
  const cardIdentity = /*#__PURE__*/jsxs(Fragment, {
    children: [!hidden && /*#__PURE__*/_jsx("div", {
      className: `${namespace}__wrap-image ${namespace}__wrap-image--${type === null || type === void 0 ? void 0 : type.toLowerCase()}`
    }, void 0, /*#__PURE__*/_jsx(UserImage, {
      image: image,
      isMobile: isMobile,
      namespace: namespace,
      type: type
    })), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__wrap-description ${isLanding ? 'landing' : ''}`
    }, void 0, labels === null || labels === void 0 ? void 0 : labels.map(_ref2 => {
      let {
        id,
        icon,
        label
      } = _ref2;
      return /*#__PURE__*/_jsx(Labels, {
        id: id,
        icon: icon,
        label: label,
        followers: followers,
        isMobile: isMobile,
        ownerId: ownerId,
        buyerId: buyerId,
        baseURL: baseURL,
        deviceType: deviceType,
        handlePostFollow: handlePostFollow,
        theme: theme,
        flowSource: flowSource
      }, `${id}${label.text}`);
    }))]
  });
  const fullBanner = () => /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: bannerClassnames,
      style: bannerImage ? {
        backgroundImage: `url(${bannerImage})`
      } : {}
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__wrapper-components`
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__info-wrapper`
    }, void 0, !isMobile && homeUrl && !isNotClickable ? /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _jsx("div", {
      className: `${namespace}__shop-info ui-es-clickable`,
      onClick: () => redirectDefault(homeUrl, isWebview),
      role: "button",
      tabIndex: 0
    }, void 0, cardIdentity) : /*#__PURE__*/_jsx("div", {
      className: `${namespace}__shop-info`
    }, void 0, cardIdentity), socialProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase()) && followers && /*#__PURE__*/_jsx("div", {
      className: `${namespace}__actions-wrapper`
    }, void 0, _Followers || (_Followers = /*#__PURE__*/_jsx(Followers, {
      followers: followers,
      namespace: namespace,
      isMobile: isMobile,
      ownerId: ownerId,
      buyerId: buyerId,
      baseURL: baseURL,
      siteId: siteId,
      tracks: tracks,
      deviceType: deviceType,
      flowSource: flowSource
    })), _Menu || (_Menu = /*#__PURE__*/_jsx(OptionsMenu, {
      optionsMenu: optionsMenu,
      type: type
    })))), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__shop-free-shipping`
    }, void 0, children)))
  });
  const mobileBanner = () => !(socialProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase()) || superProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase())) && /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: bannerImageClassnames,
      style: bannerMobileImage ? {
        backgroundImage: `url(${bannerMobileImage})`
      } : {}
    }), shareTypes.includes(type === null || type === void 0 ? void 0 : type.toLowerCase()) && bannerMobileImage && share && /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _jsx("div", {
      className: `${namespace}__share`,
      role: "button",
      onClick: () => handleShare(isWebview, shareText, shareLink, setShowSnackbar, tracks, 'native'),
      tabIndex: 0
    }, void 0, _Share || (_Share = /*#__PURE__*/_jsx(Share16, {
      color: constants_1$1.ANDES_BLUE_500
    })))]
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: isMobile ? mobileBanner() : fullBanner()
  });
};
Banner.defaultProps = {
  banner: {
    url: ''
  },
  followers: {
    cta_status: null,
    ctas: [],
    text: 'Seguidores',
    follows_entity: {}
  },
  optionsMenu: {},
  share: null
};
var _svg$3;
const namespace$7 = 'ui-ms-profile__corridors-icon';
const Corridors = () => _svg$3 || (_svg$3 = /*#__PURE__*/_jsx("svg", {
  className: namespace$7,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, void 0, /*#__PURE__*/_jsx("path", {
  d: "M1.25 2.45H7.25L7.25 1.25H1.25V2.45Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M6.05 1.75L6.05 7.25L7.25 7.25L7.25 1.75L6.05 1.75Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M7.25 6.05L1.25 6.05L1.25 7.25L7.25 7.25L7.25 6.05Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M2.45 7.25L2.45 1.75L1.25 1.75L1.25 7.25L2.45 7.25Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M8.75 2.45H14.75L14.75 1.25H8.75V2.45Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M13.55 1.75L13.55 7.25L14.75 7.25L14.75 1.75L13.55 1.75Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M14.75 6.05L8.75 6.05L8.75 7.25L14.75 7.25L14.75 6.05Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M9.95 7.25L9.95 1.75L8.75 1.75L8.75 7.25L9.95 7.25Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M1.25 9.95H7.25L7.25 8.75H1.25V9.95Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M6.05 9.25L6.05 14.75L7.25 14.75L7.25 9.25L6.05 9.25Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M7.25 13.55L1.25 13.55L1.25 14.75L7.25 14.75L7.25 13.55Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M2.45 14.75L2.45 9.25L1.25 9.25L1.25 14.75L2.45 14.75Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M8.75 9.95H14.75L14.75 8.75H8.75V9.95Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M13.55 9.25L13.55 14.75L14.75 14.75L14.75 9.25L13.55 9.25Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M14.75 13.55L8.75 13.55L8.75 14.75L14.75 14.75L14.75 13.55Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx("path", {
  d: "M9.95 14.75L9.95 9.25L8.75 9.25L8.75 14.75L9.95 14.75Z",
  fill: "#3483FA"
})));
var _Corridors;
const ProfileInfo = _ref => {
  var _labels$find, _Fragment;
  let {
    buyerId,
    baseURL,
    contextualMenu,
    followers,
    image,
    isMobile,
    isWebview,
    labels,
    namespace,
    optionsMenu,
    ownerId,
    socialProfileType,
    type,
    siteId,
    tracks,
    onMenuClick,
    barInfo,
    deviceType,
    handlePostFollow,
    flowSource
  } = _ref;
  const {
    target: homeUrl,
    hidden = false
  } = image || {};
  const {
    text: menuText,
    deep_link: deepLink
  } = contextualMenu || {};
  const nameEshop = labels === null || labels === void 0 || (_labels$find = labels.find(label => label.id === 'full_name')) === null || _labels$find === void 0 || (_labels$find = _labels$find.label) === null || _labels$find === void 0 ? void 0 : _labels$find.text;
  const upperCaseType = type.toUpperCase();
  const isAffiliate = upperCaseType === storefrontType.Affiliate;
  const isSocial = upperCaseType === storefrontType.Social;
  const isLanding = upperCaseType === storefrontType.Landing;
  const isSuperOrLanding = [storefrontType.Super, storefrontType.SuperPartner, storefrontType.Landing].includes(upperCaseType);
  const isNotClickable = isAffiliate || isSocial;
  const clickableClass = upperCaseType === storefrontType.Landing ? ' ui-es-clickable' : '';
  const profileClassnames = classNames(`${namespace}__profile-mobile`, {
    'profile--social': socialProfileType === null || socialProfileType === void 0 ? void 0 : socialProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase()),
    [`${namespace}__profile-mobile--supermarket`]: isSuperOrLanding
  });
  const menuLink = dLink => {
    if (dLink.startsWith('http') && isWebview) {
      const urlEncode = encodeURIComponent(dLink);
      return `meli://webview/?webkit-engine=2&refresh_mode=pull&hides_bottom_bar=true&bar_content_color=FFFFFF&bar_visibility=gone&url=${urlEncode}`;
    }
    return dLink;
  };
  const handleMenuOnClick = () => {
    const link = menuLink(deepLink);
    onMenuClick(link);
  };
  const imageFormat = /*#__PURE__*/_jsx(UserImage, {
    namespace: namespace,
    type: type,
    image: image,
    isMobile: isMobile,
    nameEshop: nameEshop
  });
  const wrapImage = homeUrl && !isNotClickable ? /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  _jsx("div", {
    className: `${namespace}__profile-image ui-es-clickable`,
    onClick: () => redirectDefault(homeUrl, isWebview),
    "data-testid": "logo-button",
    role: "button",
    tabIndex: 0
  }, void 0, imageFormat) : /*#__PURE__*/_jsx("div", {
    className: `${namespace}__profile-image`
  }, void 0, imageFormat);
  const renderProfile = () => {
    if (isMobile) {
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: `${profileClassnames}`
        }, void 0, !hidden && wrapImage, /*#__PURE__*/_jsx("div", {
          className: `${namespace}__profile-information${clickableClass}`
        }, void 0, isLanding && labels.map(_ref2 => {
          let {
            id,
            icon,
            label
          } = _ref2;
          return /*#__PURE__*/_jsx(Labels, {
            id: id,
            icon: icon,
            label: label,
            followers: followers,
            isMobile: isMobile,
            ownerId: ownerId,
            buyerId: buyerId,
            baseURL: baseURL,
            type: type,
            siteId: siteId,
            tracks: tracks,
            onClick: () => redirectDefault(homeUrl, isWebview),
            role: "button",
            deviceType: deviceType,
            flowSource: flowSource
          }, `${id}${label.text}`);
        }), !isLanding && labels.map(_ref3 => {
          let {
            id,
            icon,
            label
          } = _ref3;
          return /*#__PURE__*/_jsx(Labels, {
            id: id,
            icon: icon,
            label: label,
            followers: followers,
            isMobile: isMobile,
            ownerId: ownerId,
            buyerId: buyerId,
            baseURL: baseURL,
            type: type,
            siteId: siteId,
            tracks: tracks,
            barInfo: barInfo,
            deviceType: deviceType,
            handlePostFollow: handlePostFollow,
            flowSource: flowSource
          }, `${id}${label.text}`);
        })), !(socialProfileType !== null && socialProfileType !== void 0 && socialProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase())) && /*#__PURE__*/_jsx("div", {
          className: `${namespace}__profile-mobile-menu`
        }, void 0, /*#__PURE__*/_jsx(Button, {
          "data-testid": "menu-button",
          hierarchy: "transparent",
          size: "small",
          onClick: () => handleMenuOnClick()
        }, void 0, isSuperOrLanding && (_Corridors || (_Corridors = /*#__PURE__*/_jsx(Corridors, {}))), menuText))), (socialProfileType === null || socialProfileType === void 0 ? void 0 : socialProfileType.includes(type === null || type === void 0 ? void 0 : type.toLowerCase())) && (_Fragment || (_Fragment = /*#__PURE__*/jsx(Fragment, {
          children: /*#__PURE__*/_jsx(OptionsMenu, {
            optionsMenu: optionsMenu,
            isWebview: isWebview
          })
        })))]
      });
    }
    return null;
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: renderProfile()
  });
};
ProfileInfo.defaultProps = {
  followers: {
    cta_status: null,
    ctas: [],
    follows_entity: {}
  },
  labels: []
};
const namespace$6 = 'ui-ms-modal-wrapper--eshop';
const ModalWrapper = _ref => {
  let {
    id,
    title,
    content,
    is_open: isOpenProp,
    type,
    closable,
    setCategoryAdults
  } = _ref;
  const {
    text,
    primary_action: primaryAction,
    secondary_action: secondaryAction
  } = content;
  const [isOpen, setIsOpen] = useState(isOpenProp);
  const size = type === 'card' || type === 'full' ? 'medium' : 'large';
  const closeModal = () => {
    var _localStorage;
    setCategoryAdults(false);
    (_localStorage = localStorage) === null || _localStorage === void 0 || _localStorage.setItem('storefront-adults-category', false);
    setIsOpen(false);
    window.location.href = secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.href;
  };
  const actionPrimary = /*#__PURE__*/_jsx(Button, {
    id: primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.id,
    href: primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.href,
    onClick: () => {
      var _localStorage2;
      setCategoryAdults(true);
      (_localStorage2 = localStorage) === null || _localStorage2 === void 0 || _localStorage2.setItem('storefront-adults-category', true);
      setIsOpen(false);
    },
    size: size
  }, void 0, primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.text);
  const actionSecondary = /*#__PURE__*/_jsx(Button, {
    id: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.id,
    hierarchy: "quiet",
    href: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.href,
    onClick: () => closeModal(),
    size: size
  }, void 0, secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.text);
  const markdownWrapper = contentWithLink => {
    const options = {
      forceBlock: true
    };
    return /*#__PURE__*/_jsx(Markdown, {
      options: options
    }, void 0, contentWithLink);
  };
  return /*#__PURE__*/_jsx(Modal, {
    id: id,
    className: namespace$6,
    title: title,
    srLabel: title,
    type: type,
    open: isOpen,
    showCloseButton: closable,
    closeButtonSrLabel: "cerrar",
    onClose: () => closeModal(),
    closeUrl: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.href,
    actions: {
      primary: actionPrimary,
      secondary: actionSecondary
    }
  }, void 0, markdownWrapper(text));
};
const ICONS = {
  coupon: /*#__PURE__*/_jsx(Coupon, {})
};
const BarInfo = _ref => {
  let {
    icon,
    visible,
    text,
    isMobile
  } = _ref;
  const namespace = 'ui-es-profile-header__bar-info';
  if (!visible || !isMobile) {
    return null;
  }
  const Icon = ICONS[icon];
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, Icon && /*#__PURE__*/React.cloneElement(Icon), /*#__PURE__*/_jsx("p", {}, void 0, text));
};
const socialProfileType = [constants_1$1.TYPES.AFFILIATE, constants_1$1.TYPES.SOCIAL];
const superProfileType = [constants_1$1.TYPES.SUPER, constants_1$1.TYPES.SUPER_PARTNER];
const typesWithLimitL2 = [constants_1$1.TYPES.SELLER, constants_1$1.TYPES.BRAND];
const ProfileHeader = _ref => {
  let {
    namespace,
    type,
    banner,
    image,
    labels,
    options_menu: optionsMenu,
    menu,
    menu_type: menuType,
    behavior,
    isWebview,
    contextual_menu: contextualMenu,
    device_type: deviceType,
    followers,
    children,
    ownerId: oOwnerId,
    buyerId: oBuyerId,
    owner_id: _ownerId,
    buyer_id: _buyerId,
    baseURL,
    siteId,
    tracks,
    share,
    adult_modal: adultModal,
    setIsOpen,
    setUrl,
    isEditable,
    isOpenOverlay,
    bar_info: barInfo = {},
    callAfterFollow = () => {},
    theme,
    flowSource,
    trackingData
  } = _ref;
  const typeLowerCase = type === null || type === void 0 ? void 0 : type.toLowerCase();
  const [firstRender, setFirstRender] = useState(true);
  const isMobile = deviceType === 'mobile' || deviceType === 'native';
  const ownerId = oOwnerId !== null && oOwnerId !== void 0 ? oOwnerId : _ownerId;
  const buyerId = oBuyerId !== null && oBuyerId !== void 0 ? oBuyerId : _buyerId;
  const {
    url: bannerUrl
  } = banner || {};
  const isHiddenNodeHeader = constants_1$1.HIDDEN_NODE_HEADER === null || constants_1$1.HIDDEN_NODE_HEADER === void 0 ? void 0 : constants_1$1.HIDDEN_NODE_HEADER.includes(typeLowerCase);
  const snackbarMessage = share === null || share === void 0 ? void 0 : share.snackbar_message;
  const shopInfoCoupon = (barInfo === null || barInfo === void 0 ? void 0 : barInfo.visible) && (followers === null || followers === void 0 ? void 0 : followers.cta_status) === 'do_follow';
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [categoryAdults, setCategoryAdults] = useState(null);
  const [showBarInfo, setShowBarInfo] = useState(shopInfoCoupon);
  const [profileClassnames, setProfileClassnames] = useState(classNames(`${namespace}__header`, {
    [`${namespace}__header--full-banner`]: bannerUrl,
    [`${namespace}__header--${typeLowerCase}`]: type,
    [`${namespace}--with-adult-modal`]: adultModal && !categoryAdults
  }));
  const hasCalledNativeBottomSheet = useRef(false);
  const isValid = () => typeof window !== 'undefined' && typeof window.document !== 'undefined' && window.document.body !== null && snackbarMessage;
  const handleMenuClick = async url => {
    const openBottomSheet = () => {
      setIsOpen(true);
      setUrl(url);
    };
    redirectEvent(url, isWebview, behavior, hasCalledNativeBottomSheet, openBottomSheet);
  };
  useEffect(() => {
    var _data$client, _data$client$toLowerC;
    const {
      melidata_track: melidataTrack
    } = tracks;
    const {
      event_data: data,
      type: trackType,
      extra_data: extraData
    } = melidataTrack;
    const validateClientTrack = ['home', 'search', 'vpp'].includes(data === null || data === void 0 || (_data$client = data.client) === null || _data$client === void 0 || (_data$client$toLowerC = _data$client.toLowerCase) === null || _data$client$toLowerC === void 0 ? void 0 : _data$client$toLowerC.call(_data$client)) ? data.client.toLowerCase() : 'no_valid_client';
    const newData = _objectSpread(_objectSpread({}, data), {}, {
      client: validateClientTrack,
      flow_source: flowSource || 'NOT_SPECIFIED'
    });
    MelidataTrack.sendTrack(MelidataTrack.PATHS.RENDER_COMPONENT, newData, trackType, extraData);
  }, []);
  useEffect(() => {
    if (showSnackbar) {
      setTimeout(() => {
        setShowSnackbar(false);
      }, 5000);
    }
  }, [showSnackbar]);
  const forceRefresh = () => {
    window.MobileWebKit.navigation.reload();
  };
  useEffect(() => {
    if (!firstRender) {
      if (!buyerId && window.MobileWebKit) {
        var _window$MobileWebKit;
        (_window$MobileWebKit = window.MobileWebKit) === null || _window$MobileWebKit === void 0 || (_window$MobileWebKit = _window$MobileWebKit.lifecycle) === null || _window$MobileWebKit === void 0 || _window$MobileWebKit.onViewAppeared(forceRefresh);
      }
    } else {
      setFirstRender(false);
    }
  }, [buyerId, firstRender]);
  useEffect(() => {
    if (window.MobileWebKit && window.MobileWebKit.platform === 'android') {
      window.MobileWebKit.lifecycle.onViewAppeared(() => {
        hasCalledNativeBottomSheet.current = false;
      });
    }
  }, []);
  useEffect(() => {
    var _localStorage;
    const localCategoryAdults = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('storefront-adults-category');
    setCategoryAdults(localCategoryAdults === 'true');
  }, []);
  useEffect(() => {
    if (categoryAdults) {
      setProfileClassnames(profileClassnames.replace(`${namespace}--with-adult-modal`, ''));
    }
  }, [categoryAdults]);
  const limitL2 = typesWithLimitL2.includes(typeLowerCase) ? constants_1$1.MAX_L2[typeLowerCase] : null;
  const handlePostFollow = followState => {
    if ((followState === null || followState === void 0 ? void 0 : followState.action) === 'do_follow' && shopInfoCoupon) {
      setShowBarInfo(false);
    }
    callAfterFollow(followState);
  };
  useEffect(() => {
    if ((barInfo === null || barInfo === void 0 ? void 0 : barInfo.visible) === false) {
      setShowBarInfo(false);
    }
  }, [barInfo === null || barInfo === void 0 ? void 0 : barInfo.visible]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: profileClassnames
    }, void 0, categoryAdults === false && adultModal && /*#__PURE__*/jsx(ModalWrapper, _objectSpread(_objectSpread({}, adultModal), {}, {
      setCategoryAdults: setCategoryAdults
    })), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Banner, {
      banner: banner,
      buyerId: buyerId,
      baseURL: baseURL,
      contextualMenu: contextualMenu,
      followers: followers,
      image: image,
      isMobile: isMobile,
      labels: labels,
      namespace: namespace,
      optionsMenu: optionsMenu,
      ownerId: ownerId,
      socialProfileType: socialProfileType,
      superProfileType: superProfileType,
      type: type,
      isWebview: isWebview,
      siteId: siteId,
      tracks: tracks,
      share: share,
      setShowSnackbar: setShowSnackbar,
      deviceType: deviceType,
      handlePostFollow: handlePostFollow,
      theme: theme,
      flowSource: flowSource
    }, void 0, children)), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__container`
    }, void 0, /*#__PURE__*/_jsx(ProfileInfo, {
      menuType: menuType,
      banner: banner,
      baseURL: baseURL,
      buyerId: buyerId,
      contextualMenu: contextualMenu,
      followers: followers,
      image: image,
      isMobile: isMobile,
      isWebview: isWebview,
      labels: labels,
      namespace: namespace,
      optionsMenu: optionsMenu,
      behavior: behavior,
      ownerId: ownerId,
      socialProfileType: socialProfileType,
      type: type,
      siteId: siteId,
      tracks: tracks,
      onMenuClick: handleMenuClick,
      barInfo: barInfo,
      deviceType: deviceType,
      handlePostFollow: handlePostFollow,
      flowSource: flowSource
    }), !(socialProfileType !== null && socialProfileType !== void 0 && socialProfileType.includes(typeLowerCase)) && !isMobile && /*#__PURE__*/_jsx(NavigationBar, {
      type: type,
      baseURL: baseURL,
      buyerId: buyerId,
      categoriesLabel: menu === null || menu === void 0 ? void 0 : menu.categories_label,
      categoriesSelected: menu === null || menu === void 0 ? void 0 : menu.categories_selected,
      followers: followers,
      isMobile: isMobile,
      maxNodesInLine: menu === null || menu === void 0 ? void 0 : menu.max_nodes_in_line,
      menuL1: menu === null || menu === void 0 ? void 0 : menu.nodes,
      menuType: menuType,
      withSeparator: menu === null || menu === void 0 ? void 0 : menu.with_separator,
      ownerId: ownerId,
      viewAllLabel: menu === null || menu === void 0 ? void 0 : menu.view_all_label,
      siteId: siteId,
      tracks: tracks,
      share: share,
      isHiddenNodeHeader: isHiddenNodeHeader,
      setShowSnackbar: setShowSnackbar,
      isEditable: isEditable,
      isOpenOverlay: isOpenOverlay,
      limitL2: limitL2,
      barInfo: barInfo,
      deviceType: deviceType,
      handlePostFollow: handlePostFollow,
      flowSource: flowSource,
      trackingData: trackingData
    })), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__search-border`
    })), /*#__PURE__*/jsx(BarInfo, _objectSpread(_objectSpread({}, barInfo), {}, {
      isMobile: isMobile,
      visible: showBarInfo
    })), isValid() && /*#__PURE__*/_jsx(Snackbar$1, {
      color: "black",
      delay: 5000,
      message: snackbarMessage,
      show: showSnackbar
    })]
  });
};
ProfileHeader.defaultProps = {
  namespace: 'ui-ms-profile',
  banner: {
    url: ''
  },
  description: null,
  followers: null,
  image: {
    url: 'https://www.mercadolibre.com/org-img/mkt/email-mkt-assets/my-profile/ML/profileIcon.svg'
  },
  sideBarMenuVisible: false,
  title: null,
  adult_modal: null,
  isEditable: false,
  isOpenOverlay: false,
  theme: ''
};
var _Fragment, _ChevronRight;
const RIPPLE_CLASS = 'sidebar-content_ripple';
const SidebarMenu = _ref => {
  let {
    menuItem,
    categoryHandler,
    home,
    handleMenu,
    categoryLinkHandler,
    isHiddenNodeHeader,
    isEditable
  } = _ref;
  const addRippleEffect = event => {
    const button = event.currentTarget;
    const circle = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    circle.style.width = `${diameter}px`;
    circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add(RIPPLE_CLASS);
    const ripple = button.getElementsByClassName(RIPPLE_CLASS)[0];
    if (ripple) {
      ripple.remove();
    }
    button.appendChild(circle);
  };
  return /*#__PURE__*/_jsx(List, {
    srLabel: "menu",
    withDividers: true
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "menu-title",
    onClick: handleMenu,
    role: "button",
    tabIndex: 0
  }, void 0, /*#__PURE__*/_jsx("p", {
    "data-testid": "home-menu-button"
  }, void 0, home)), menuItem.map(category => {
    const {
      number_of_menu_items: menuItemsQty,
      in_header: inHeader,
      hidden,
      type,
      nodes
    } = category;
    const isFolderEmpty = type === 'FOLDER' && !(nodes !== null && nodes !== void 0 && nodes.length);
    const validateType = () => type === 'FOLDER' && (nodes === null || nodes === void 0 ? void 0 : nodes.length);
    if (isHiddenNodeHeader && inHeader === false && isCCP(category.id) || isEditable && hidden === true || isFolderEmpty) {
      return _Fragment || (_Fragment = /*#__PURE__*/jsx(Fragment, {}));
    }
    return /*#__PURE__*/_jsx("div", {
      className: "sidebar-content__item--container"
    }, category.id || category.name, /*#__PURE__*/_jsx(ListItem, {
      srLabel: category.name,
      className: "sidebar-content__item",
      title: category.name,
      onClick: event => {
        categoryLinkHandler(category);
        addRippleEffect(event);
      }
    }), (menuItemsQty > 1 || validateType()) && /*#__PURE__*/_jsx("div", {
      className: "sidebar-content__item--chevron",
      role: "button",
      name: "chevron-btn",
      tabIndex: 0,
      onClick: () => categoryHandler(category),
      "data-testid": "menu-chevron"
    }, void 0, _ChevronRight || (_ChevronRight = /*#__PURE__*/_jsx(ChevronRight20, {}))));
  }));
};
const categoryProptype = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string
});
categoryProptype.nodes = PropTypes.arrayOf(categoryProptype);
SidebarMenu.defaultProps = {
  isHiddenNodeHeader: false,
  isEditable: false
};
var _ArrowLeft, _Close$2;
const SidebarTitle = _ref => {
  let {
    label,
    title,
    closeSidebar,
    categoryBack,
    isSubNode
  } = _ref;
  const classTitle = classNames('sidebar-title', {
    'sidebar-title--subnode': isSubNode
  });
  return /*#__PURE__*/_jsx("div", {
    className: classTitle
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "sidebar-title__content"
  }, void 0, isSubNode && /*#__PURE__*/_jsx("div", {
    "data-testid": "category-back-button",
    className: "sidebar-title__content-back",
    tabIndex: 0,
    role: "button",
    onClick: categoryBack
  }, void 0, _ArrowLeft || (_ArrowLeft = /*#__PURE__*/_jsx(ArrowLeft24, {}))), /*#__PURE__*/_jsx("h1", {}, void 0, label || title), /*#__PURE__*/_jsx("div", {
    className: "sidebar-title__content-close",
    "data-testid": "close-sidebar-button",
    tabIndex: 0,
    role: "button",
    onClick: closeSidebar
  }, void 0, _Close$2 || (_Close$2 = /*#__PURE__*/_jsx(Close24, {})))));
};
const getCountryFromUrl = function () {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    location: {
      href: ''
    }
  };
  const url = window.location.href;
  if (url !== null && url !== void 0 && url.includes('.br')) {
    return 'pt';
  }
  if (url !== null && url !== void 0 && url.includes('.mx')) {
    return 'es';
  }
  return 'default';
};
const Sidebar = _ref => {
  var _menu$sale;
  let {
    type,
    nodes: menuItem,
    label,
    labelUrl,
    name,
    home,
    showMenu,
    menu,
    isWebview,
    osName,
    shopType,
    isEditable,
    currentCategorySelected,
    categoryHandlerPersist
  } = _ref;
  const menuOptions = menuItem !== null && menuItem !== void 0 ? menuItem : menu === null || menu === void 0 ? void 0 : menu.nodes;
  const saleOption = (_menu$sale = menu.sale) !== null && _menu$sale !== void 0 ? _menu$sale : null;
  const isHiddenNodeHeader = constants_1$1.HIDDEN_NODE_HEADER === null || constants_1$1.HIDDEN_NODE_HEADER === void 0 ? void 0 : constants_1$1.HIDDEN_NODE_HEADER.includes(shopType === null || shopType === void 0 ? void 0 : shopType.toLowerCase());
  if (saleOption && !menuOptions.some(elem => elem.id === 'sale')) {
    const saleNode = {
      id: 'sale',
      name: saleOption.text,
      url: saleOption.url,
      nodes: [],
      number_of_menu_items: 1
    };
    menuOptions.unshift(saleNode);
  }
  const [currentCategories, setCurrentCategories] = useState(() => {
    if (isEditable) {
      return (currentCategorySelected === null || currentCategorySelected === void 0 ? void 0 : currentCategorySelected.nodes) || menuOptions;
    }
    return menuOptions;
  });
  const [currentTitle, setCurrentTitle] = useState(() => {
    if (isEditable) {
      return (currentCategorySelected === null || currentCategorySelected === void 0 ? void 0 : currentCategorySelected.name) || home;
    }
    return home;
  });
  const [currentCategoryId, setCurrentCategoryId] = useState(() => {
    if (isEditable) {
      return (currentCategorySelected === null || currentCategorySelected === void 0 ? void 0 : currentCategorySelected.id) || '';
    }
    return '';
  });
  const [categoryHistory, setCategoryHistory] = useState(() => {
    if (isEditable && currentCategorySelected !== null && currentCategorySelected !== void 0 && currentCategorySelected.id) {
      return [{
        nodes: menuOptions,
        name
      }, currentCategorySelected];
    }
    return [{
      nodes: menuOptions,
      name
    }];
  });
  const {
    unsubscribe,
    subscribe,
    emit
  } = useMessage();
  const sidebarClass = classNames('sidebar', 'layout__float', 'layout__float-show', `layout__float--${type}`, {
    'eshops-sidebar--ios': osName && osName.toLowerCase() === 'ios' || isWebview && osName === undefined
  });
  const sidebarContentClass = classNames('sidebar-content', `sidebar-content--${type}`);
  const categoryBack = () => {
    if (isEditable) {
      emit('menu-panel', 'toggleSubMenuComponent', {
        isOpen: false,
        itemId: currentCategoryId
      });
    }
    const category = categoryHistory[categoryHistory.length - 2];
    setCategoryHistory(categoryHistory.slice(0, categoryHistory.length - 1));
    setCurrentCategories(category.nodes);
    setCurrentTitle(home);
    setCurrentCategoryId('');
  };
  const translations = {
    pt: 'Tudo de',
    es: 'Todo en',
    default: 'Todo en'
  };
  const country = typeof window !== 'undefined' ? getCountryFromUrl(window) : null;
  const labelTranslation = country ? translations[country] || translations.es : translations.default;
  const isSubNode = categoryHistory.length > 1;
  const labelMenu = isSubNode ? `${labelTranslation} ${currentTitle}` : label;
  const categoryHandler = category => {
    if (category.nodes && category.nodes.length > 0) {
      if (isEditable) {
        emit('menu-panel', 'toggleSubMenuComponent', {
          isOpen: true,
          itemId: category.id
        });
        categoryHandlerPersist(category);
      }
      setCurrentCategories(category.nodes);
      setCurrentTitle(category.name);
      setCurrentCategoryId(category.id);
      setCategoryHistory([...categoryHistory, category]);
    } else {
      window.location.href = category.url;
    }
  };
  const categoryLinkHandler = category => {
    if (isEditable) {
      return;
    }
    if (category.url === '') {
      categoryHandler(category);
      return;
    }
    window.location.href = category.url;
  };
  const handleTitleLink = () => {
    if (isEditable) {
      return;
    }
    if (typeof window !== 'undefined') {
      if (isSubNode) {
        const currentCategory = categoryHistory.filter(category => category.name === currentTitle)[0];
        if (currentCategory !== null && currentCategory !== void 0 && currentCategory.url) {
          window.location = currentCategory.url;
        }
      } else if (labelUrl) {
        window.location.href = labelUrl;
      }
    }
  };
  const closeMenu = () => {
    if (isEditable) {
      return;
    }
    if (isWebview) {
      if (typeof window !== 'undefined' && window.MobileWebKit && window.MobileWebKit.navigation) {
        window.MobileWebKit.navigation.pop();
      }
    } else if (typeof window !== 'undefined') {
      window.history.back();
    }
  };
  const resetMenu = () => {
    setCategoryHistory([{
      nodes: menuOptions,
      name
    }]);
    setCurrentCategories(menuOptions);
    setCurrentCategoryId('');
    setCurrentTitle(home);
  };
  const canAddNodeToHistory = _ref2 => {
    var _menuOptions$find;
    let {
      id
    } = _ref2;
    const updatedItem = (_menuOptions$find = menuOptions.find(option => (option === null || option === void 0 ? void 0 : option.id) === id)) !== null && _menuOptions$find !== void 0 ? _menuOptions$find : {};
    let nodeToHistory = {
      isValid: false
    };
    if (updatedItem.id) {
      let isValid;
      if (updatedItem.hidden === true) {
        isValid = false;
      } else {
        var _updatedItem$nodes;
        const isNodesValid = (updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.number_of_menu_items) > 0 && (updatedItem === null || updatedItem === void 0 || (_updatedItem$nodes = updatedItem.nodes) === null || _updatedItem$nodes === void 0 ? void 0 : _updatedItem$nodes.length) > 0;
        isValid = 'hidden' in updatedItem ? isNodesValid && updatedItem.nodes.some(node => node.hidden === false) : isNodesValid;
      }
      nodeToHistory = _objectSpread(_objectSpread({}, updatedItem), {}, {
        isValid
      });
    }
    return nodeToHistory;
  };
  const subscribeToMenuActions = (messageGroup, action, payload) => {
    if (messageGroup !== 'menu-panel' || action !== 'toggleSubMenu') return;
    const {
      isOpen,
      item
    } = payload;
    if (isOpen === false) {
      resetMenu();
    } else {
      const nodeToHistory = canAddNodeToHistory({
        id: item === null || item === void 0 ? void 0 : item.id
      });
      if (nodeToHistory.isValid) {
        setCurrentTitle(nodeToHistory.name);
        setCategoryHistory([{
          nodes: menuOptions,
          name
        }, nodeToHistory]);
        setCurrentCategories(nodeToHistory.nodes);
        setCurrentCategoryId(item === null || item === void 0 ? void 0 : item.id);
      } else {
        resetMenu();
      }
    }
  };
  useEffect(() => {
    if (!isEditable || !Array.isArray(menuOptions)) {
      return () => {};
    }
    subscribe(subscribeToMenuActions);
    let previousHistoryUpdated = {
      isValid: false
    };
    if (currentCategoryId) {
      previousHistoryUpdated = canAddNodeToHistory({
        id: currentCategoryId
      });
    }
    if (previousHistoryUpdated.isValid) {
      setCurrentTitle(previousHistoryUpdated.name);
      setCategoryHistory([{
        nodes: menuOptions,
        name
      }, previousHistoryUpdated]);
      setCurrentCategories(previousHistoryUpdated.nodes);
    } else {
      resetMenu();
    }
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuOptions]);
  const resolvedLabel = (shopType === null || shopType === void 0 ? void 0 : shopType.toLowerCase()) === constants$1.TYPES.LANDING ? 'Explorar' : currentTitle;
  return showMenu && /*#__PURE__*/_jsx("div", {
    className: sidebarClass
  }, void 0, /*#__PURE__*/_jsx(SidebarTitle, {
    title: resolvedLabel,
    closeSidebar: () => closeMenu(),
    categoryBack: categoryBack,
    isSubNode: isSubNode
  }), /*#__PURE__*/_jsx("div", {
    className: sidebarContentClass
  }, void 0, /*#__PURE__*/_jsx(SidebarMenu, {
    isEditable: isEditable,
    handleMenu: () => handleTitleLink(),
    menuItem: currentCategories,
    categoryHandler: categoryHandler,
    home: labelMenu,
    isHiddenNodeHeader: isHiddenNodeHeader,
    categoryLinkHandler: categoryLinkHandler
  })));
};
Sidebar.defaultProps = {
  type: 'full',
  shopType: '',
  isEditable: false,
  categoryHandlerPersist: () => {}
};
var _svg$2;
const NoListingSmall = () => _svg$2 || (_svg$2 = /*#__PURE__*/_jsx("svg", {
  "aria-hidden": "true",
  width: 240,
  height: 57,
  viewBox: "0 0 240 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.169 56c6.377-3.719 12.622-9.136 16.347-15.62 6.536-11.378 5.635-19.676 2.275-28.118C154.395 3.728 141.983-1.3 132.441.293c-9.542 1.593-16.221 11.498-29.09 12.919C90.483 14.633 80.021 21.369 77.019 31c-3.152 10.114 3.02 18.568 8.569 22.62a59.518 59.518 0 003.465 2.36L139.17 56z",
  fill: "#000",
  fillOpacity: 0.04
}), /*#__PURE__*/_jsx("path", {
  d: "M74.024 37.356c15.281 0 16.705 18.534 16.705 18.534s2.771-13.298 11.985-13.298c9.213 0 11.985 13.298 11.985 13.298s1.873-24.518 16.704-24.518",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeDasharray: "4 4"
}), /*#__PURE__*/_jsx("path", {
  d: "M141.589 8.074a6.293 6.293 0 003.402-.63 3.277 3.277 0 012.924 0 6.29 6.29 0 003.401.63 3.267 3.267 0 012.72 1.045 6.272 6.272 0 002.948 1.811c.982.274 1.784 1 2.149 1.943a6.23 6.23 0 002.092 2.751 3.206 3.206 0 011.293 2.576 6.195 6.195 0 00.95 3.317c.54.858.639 1.923.268 2.865a6.187 6.187 0 00-.32 3.434 3.196 3.196 0 01-.794 2.766 6.217 6.217 0 00-1.548 3.087 3.222 3.222 0 01-1.75 2.299 6.25 6.25 0 00-2.564 2.32 3.256 3.256 0 01-2.476 1.52 6.285 6.285 0 00-3.23 1.242 3.275 3.275 0 01-2.871.532 6.297 6.297 0 00-3.46 0 3.274 3.274 0 01-2.871-.532 6.291 6.291 0 00-3.23-1.241 3.255 3.255 0 01-2.476-1.521 6.26 6.26 0 00-2.565-2.32 3.227 3.227 0 01-1.75-2.299 6.209 6.209 0 00-1.548-3.087 3.195 3.195 0 01-.793-2.766 6.178 6.178 0 00-.321-3.434 3.188 3.188 0 01.268-2.865 6.195 6.195 0 00.95-3.317 3.211 3.211 0 011.293-2.576 6.24 6.24 0 002.093-2.75 3.238 3.238 0 012.149-1.944 6.282 6.282 0 002.948-1.81 3.266 3.266 0 012.719-1.046z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 3
}), /*#__PURE__*/_jsx("path", {
  d: "M144.322 6.101a4.776 4.776 0 014.262 0v0c.8.399 1.7.565 2.59.48v0a4.767 4.767 0 013.97 1.527v0a4.777 4.777 0 002.242 1.377v0a4.741 4.741 0 013.146 2.848v0c.321.83.874 1.556 1.588 2.088v0a4.706 4.706 0 011.898 3.784v0a4.695 4.695 0 00.72 2.514v0a4.69 4.69 0 01.394 4.213v0a4.687 4.687 0 00-.243 2.6v0a4.694 4.694 0 01-1.166 4.069v0a4.724 4.724 0 00-1.174 2.34v0a4.721 4.721 0 01-2.565 3.374v0a4.76 4.76 0 00-1.949 1.763v0a4.755 4.755 0 01-3.619 2.225v0a4.785 4.785 0 00-2.458.944v0a4.776 4.776 0 01-4.188.778v0a4.798 4.798 0 00-2.635 0v0a4.774 4.774 0 01-4.187-.778v0a4.791 4.791 0 00-2.458-.944v0a4.758 4.758 0 01-3.62-2.225v0a4.757 4.757 0 00-1.948-1.763v0a4.725 4.725 0 01-2.566-3.373v0a4.708 4.708 0 00-1.174-2.341v0a4.697 4.697 0 01-1.166-4.068v0a4.678 4.678 0 00-.242-2.601v0a4.687 4.687 0 01.393-4.213v0a4.695 4.695 0 00.72-2.514v0a4.708 4.708 0 011.898-3.784v0a4.74 4.74 0 001.589-2.088v0a4.738 4.738 0 013.145-2.848v0a4.772 4.772 0 002.242-1.377v0a4.768 4.768 0 013.971-1.527v0c.89.085 1.79-.081 2.59-.48v0z",
  stroke: "#333",
  strokeWidth: 1.5
}), /*#__PURE__*/_jsx("path", {
  d: "M137.063 6.718a6.078 6.078 0 015.197 5.015M138.498 23.923c-1.224-.31-3.181.637-3.519 1.956M122.762 20.582c-.814-.279-2.197.254-2.503 1.131M131.505 18.754c.349-.442 1.3-1.225 2.31-.824M159.442 25.297c-.555-.108-1.689-.595-1.786-1.67M146.064 46.146c-.008.56-.286 1.755-1.335 2.043M127.753 15.494c1.912-1.29 5.413-1.461 8.011 0M152.162 18.432c.216 2.285-1.321 5.412-3.864 6.967M156.406 19.936s-.505-2.687 2.057-5.875 4.403-3.26 4.403-3.26M132.397 39.059c-.672-2.196.203-5.565 2.381-7.593M136.739 18.288c1.984.502 4.099 2.2 4.763 4.406",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/_jsx("path", {
  d: "M140.239 13.703c.818 1.445 2.209 5.251 1.227 8.92-.982 3.668.192 5.73.902 6.304M133.779 20.545c-3.356 1.469-5.76 4.922-6.135 9.707M129.701 24.02c.866.62 2.735 2.471 3.284 4.907M159.798 30.696c-2.618-.745-5.973.223-9.112 3.029M153.818 13.98c-2.618-.745-5.972.222-9.112 3.028M164.994 32.688c-4.366 3.474-8.699.755-9.753-1.51M148.205 14.596c-3.392-4.418-.546-8.65 1.762-9.64M137.063 33.906s2.201 1.468 2.635 4.657c.433 3.188-1.011 4.62-1.011 4.62M145.954 21.62s2.202 1.468 2.635 4.656c.433 3.188-1.011 4.621-1.011 4.621M139.806 38.778c.794-.466 2.808-1.204 4.511-.43M154.878 11.32c.883.265 2.793 1.238 3.371 3.006M130.143 2.64c.883.265 2.793 1.237 3.371 3.006M135.728 29.607c.818-.06 2.894.38 4.655 2.615 1.761 2.235 3.044 2.913 3.465 2.973M140.889 32.831c.661 0 2.151-.129 2.815-.645M147.312 38.133c1.685-.036 5.421-.48 6.893-1.97M151.606 37.524c.818.848 3.111 2.436 5.738 2.006M160.484 17.68c-.265.919-.173 3.338 2.31 5.659M130.642 7.764c-.554-.109-1.688-.595-1.785-1.671M153.313 49.2c-.555-.109-1.688-.595-1.786-1.671",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/_jsx("path", {
  d: "M85.515 56h63.747",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinecap: "square"
}), /*#__PURE__*/_jsx("path", {
  d: "M119.755 15.957a.757.757 0 01-.126-1.27c1.303-1.048 2.932-1.207 4.415-.429.493.26.559.92.125 1.27-1.303 1.049-2.931 1.207-4.414.429z",
  fill: "#fff",
  stroke: "#333",
  strokeWidth: 1.5
})));
var _svg$1;
const NoListingSuperLarge = () => _svg$1 || (_svg$1 = /*#__PURE__*/_jsx("svg", {
  width: "189",
  height: "193",
  viewBox: "0 0 189 193",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, /*#__PURE__*/_jsx("path", {
  d: "M77.1081 48.7896C84.4186 38.8555 97.783 33.4547 109.821 32.6934C126.293 31.6493 152.597 42.8194 163.072 67.8063C170.628 85.8269 168.729 118.762 136.971 138.836C135.001 140.081 132.998 141.227 130.965 142.279L39.0996 142.279C18.0507 132.64 5.44454 114.02 15.1646 95.5808C22.9702 80.7715 42.2812 76.4255 52.0665 71.6252C62.3151 66.6006 69.0804 59.6939 77.1081 48.7896Z",
  fill: "black",
  fillOpacity: "0.04"
}), /*#__PURE__*/_jsx("path", {
  d: "M176.268 141.067H14.9346",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("rect", {
  x: "45.6016",
  y: "87.6693",
  width: "92",
  height: "53.3333",
  fill: "white"
}), /*#__PURE__*/_jsx("path", {
  d: "M45.3154 102.999V86.7513H137.693V116.335V119.999M45.3154 106.999V141.091H137.693V135.335V131.001M137.693 123.999V125.651V126.999",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("rect", {
  x: "97.3838",
  y: "104.241",
  width: "27.1698",
  height: "26.566",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M106.971 125.716L118.574 114.456",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M104.85 118.727L111.188 113.188",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.2663 141.07L60.1666 115.211C60.1666 108.819 66.1105 103.637 73.4426 103.637C80.7748 103.637 86.7187 108.819 86.7187 115.211L86.8184 141.07L60.2663 141.07Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M81.9137 127.005V122.185",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("mask", {
  id: "path-10-inside-1_1220_248805",
  fill: "white"
}, void 0, /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.664 85.2702C58.664 89.8219 53.9086 93.5118 48.0425 93.5118C42.1763 93.5118 37.4209 89.8219 37.4209 85.2702L37.6014 74.7258H58.8445L58.664 85.2702ZM101.511 85.2704C101.511 89.8221 96.7557 93.512 90.8896 93.512C85.0235 93.512 80.268 89.8221 80.268 85.2704L80.4485 74.726H101.692L101.511 85.2704ZM133.737 93.512C139.603 93.512 144.358 89.8221 144.358 85.2704L144.539 74.726H123.296L123.115 85.2704C123.115 89.8221 127.871 93.512 133.737 93.512Z"
})), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.664 85.2702C58.664 89.8219 53.9086 93.5118 48.0425 93.5118C42.1763 93.5118 37.4209 89.8219 37.4209 85.2702L37.6014 74.7258H58.8445L58.664 85.2702ZM101.511 85.2704C101.511 89.8221 96.7557 93.512 90.8896 93.512C85.0235 93.512 80.268 89.8221 80.268 85.2704L80.4485 74.726H101.692L101.511 85.2704ZM133.737 93.512C139.603 93.512 144.358 89.8221 144.358 85.2704L144.539 74.726H123.296L123.115 85.2704C123.115 89.8221 127.871 93.512 133.737 93.512Z",
  fill: "#F5F5F5"
}), /*#__PURE__*/_jsx("path", {
  d: "M58.664 85.2702L54.6646 85.2018L54.664 85.236V85.2702H58.664ZM37.4209 85.2702L33.4215 85.2018L33.4209 85.236V85.2702H37.4209ZM37.6014 74.7258V70.7258H33.6692L33.6019 74.6573L37.6014 74.7258ZM58.8445 74.7258L62.8439 74.7942L62.9135 70.7258H58.8445V74.7258ZM101.511 85.2704L97.5117 85.202L97.5112 85.2362V85.2704H101.511ZM80.268 85.2704L76.2686 85.202L76.268 85.2362V85.2704H80.268ZM80.4485 74.726V70.726H76.5163L76.4491 74.6575L80.4485 74.726ZM101.692 74.726L105.691 74.7944L105.761 70.726H101.692V74.726ZM144.358 85.2704L140.359 85.202L140.358 85.2362V85.2704H144.358ZM144.539 74.726L148.538 74.7944L148.608 70.726H144.539V74.726ZM123.296 74.726V70.726H119.364L119.296 74.6575L123.296 74.726ZM123.115 85.2704L119.116 85.202L119.115 85.2362V85.2704H123.115ZM48.0425 97.5118C55.1142 97.5118 62.664 92.9159 62.664 85.2702H54.664C54.664 86.728 52.7029 89.5118 48.0425 89.5118V97.5118ZM33.4209 85.2702C33.4209 92.9159 40.9707 97.5118 48.0425 97.5118V89.5118C43.382 89.5118 41.4209 86.728 41.4209 85.2702H33.4209ZM33.6019 74.6573L33.4215 85.2018L41.4203 85.3387L41.6008 74.7942L33.6019 74.6573ZM58.8445 70.7258H37.6014V78.7258H58.8445V70.7258ZM62.6634 85.3387L62.8439 74.7942L54.8451 74.6573L54.6646 85.2018L62.6634 85.3387ZM90.8896 97.512C97.9614 97.512 105.511 92.9161 105.511 85.2704H97.5112C97.5112 86.7282 95.5501 89.512 90.8896 89.512V97.512ZM76.268 85.2704C76.268 92.9161 83.8178 97.512 90.8896 97.512V89.512C86.2291 89.512 84.268 86.7282 84.268 85.2704H76.268ZM76.4491 74.6575L76.2686 85.202L84.2674 85.3389L84.4479 74.7944L76.4491 74.6575ZM101.692 70.726H80.4485V78.726H101.692V70.726ZM105.511 85.3389L105.691 74.7944L97.6922 74.6575L97.5117 85.202L105.511 85.3389ZM140.358 85.2704C140.358 86.7282 138.397 89.512 133.737 89.512V97.512C140.809 97.512 148.358 92.9161 148.358 85.2704H140.358ZM140.54 74.6575L140.359 85.202L148.358 85.3389L148.538 74.7944L140.54 74.6575ZM123.296 78.726H144.539V70.726H123.296V78.726ZM127.115 85.3389L127.295 74.7944L119.296 74.6575L119.116 85.202L127.115 85.3389ZM133.737 89.512C129.076 89.512 127.115 86.7282 127.115 85.2704H119.115C119.115 92.9161 126.665 97.512 133.737 97.512V89.512Z",
  fill: "white",
  mask: "url(#path-10-inside-1_1220_248805)"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.0869 85.2696C80.0869 89.8213 75.3314 93.5111 69.4653 93.5111C63.5992 93.5111 58.8438 89.8213 58.8438 85.2696L59.0242 74.7251H80.2673L80.0869 85.2696Z",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.935 85.2696C122.935 89.8213 118.179 93.5111 112.313 93.5111C106.447 93.5111 101.691 89.8213 101.691 85.2696L101.872 74.7251H123.115L122.935 85.2696Z",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.664 85.2696C58.664 89.8213 53.9086 93.5111 48.0425 93.5111C42.1763 93.5111 37.4209 89.8213 37.4209 85.2696L37.6014 74.7251H58.8445L58.664 85.2696Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101.511 85.2696C101.511 89.8213 96.7553 93.5111 90.8891 93.5111C85.023 93.5111 80.2676 89.8213 80.2676 85.2696C80.2676 85.2696 80.448 74.7251 80.448 74.7251C80.448 74.7251 101.691 74.7251 101.691 74.7251C101.691 74.7251 101.511 85.2696 101.511 85.2696Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M144.357 85.2696C144.357 89.8213 139.602 93.5111 133.736 93.5111C127.87 93.5111 123.114 89.8213 123.114 85.2696C123.114 85.2696 123.295 74.7251 123.295 74.7251C123.295 74.7251 144.538 74.7251 144.538 74.7251C144.538 74.7251 144.357 85.2696 144.357 85.2696Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.5632 61.9963C46.3414 60.808 46.8874 59.9849 47.0044 59.8413C47.8199 58.8412 49.0604 58.2581 50.3728 58.2581H131.274C132.59 58.2581 133.824 58.9138 134.586 60.0176C141.633 69.4592 144.938 74.2468 144.5 74.3804C143.844 74.5808 37.0673 74.7185 37.3227 74.4047C37.3317 74.3935 37.3553 74.3653 37.3923 74.3213C37.8665 73.7585 39.942 70.6086 42.0458 67.3876L45.5632 61.9963Z",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M161.866 89.8861L154.825 82.8457",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("circle", {
  cx: "146.023",
  cy: "74.029",
  r: "11.2769",
  fill: "white",
  stroke: "white",
  strokeWidth: "4"
}), /*#__PURE__*/_jsx("circle", {
  cx: "146.023",
  cy: "74.029",
  r: "13.2769",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("rect", {
  x: "160.944",
  y: "84.2005",
  width: "15.5685",
  height: "6.71618",
  rx: "2.66667",
  transform: "rotate(45 160.944 84.2005)",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M139.382 80.863L152.719 67.3077",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M152.665 80.863L139.328 67.3077",
  stroke: "#333333",
  strokeWidth: "1.5"
})));
var _svg;
const NoListingSuperSmall = () => _svg || (_svg = /*#__PURE__*/_jsx("svg", {
  width: "143",
  height: "144",
  viewBox: "0 0 143 144",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, /*#__PURE__*/_jsx("path", {
  d: "M58.2307 36.0936C63.7136 28.6431 73.7369 24.5925 82.7654 24.0215C95.1195 23.2384 114.847 31.616 122.704 50.3562C128.371 63.8716 126.947 88.5729 103.128 103.629C101.651 104.562 100.148 105.422 98.6238 106.211L29.7244 106.211C13.9377 98.9815 4.48306 85.0168 11.7731 71.187C17.6273 60.0801 32.1106 56.8206 39.4495 53.2204C47.136 49.4519 52.2099 44.2718 58.2307 36.0936Z",
  fill: "black",
  fillOpacity: "0.04"
}), /*#__PURE__*/_jsx("path", {
  d: "M132.601 105.3H11.6006",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("rect", {
  x: "34.6016",
  y: "65.9988",
  width: "69",
  height: "40",
  fill: "white"
}), /*#__PURE__*/_jsx("path", {
  d: "M34.3867 76.9988V64.5613H103.67V86.9988M34.3867 80.9988V105.316H103.67V100.999V97.9988M103.67 90.9988V92.4988V93.9988",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("rect", {
  x: "73.4385",
  y: "77.6793",
  width: "20.3774",
  height: "19.9245",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M80.6278 93.7849L89.3304 85.34",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M79.038 88.5433L83.7908 84.389",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.5996 105.302L45.5248 85.9076C45.5248 81.1131 49.9827 77.2265 55.4819 77.2265C60.981 77.2265 65.4389 81.1131 65.4389 85.9076L65.5137 105.302L45.5996 105.302Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M61.835 94.7515V91.136",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("mask", {
  id: "path-10-inside-1_1220_248767",
  fill: "white"
}, void 0, /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.3982 63.4483C44.3982 66.8621 40.8316 69.6295 36.432 69.6295C32.0324 69.6295 28.4658 66.8621 28.4658 63.4483L28.6012 55.54H44.5335L44.3982 63.4483ZM76.5335 63.4483C76.5335 66.8621 72.9669 69.6295 68.5674 69.6295C64.1678 69.6295 60.6012 66.8621 60.6012 63.4483L60.7365 55.54H76.6689L76.5335 63.4483ZM100.703 69.6295C105.102 69.6295 108.669 66.8621 108.669 63.4483L108.804 55.54H92.8719L92.7365 63.4483C92.7365 66.8621 96.3031 69.6295 100.703 69.6295Z"
})), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.3982 63.4483C44.3982 66.8621 40.8316 69.6295 36.432 69.6295C32.0324 69.6295 28.4658 66.8621 28.4658 63.4483L28.6012 55.54H44.5335L44.3982 63.4483ZM76.5335 63.4483C76.5335 66.8621 72.9669 69.6295 68.5674 69.6295C64.1678 69.6295 60.6012 66.8621 60.6012 63.4483L60.7365 55.54H76.6689L76.5335 63.4483ZM100.703 69.6295C105.102 69.6295 108.669 66.8621 108.669 63.4483L108.804 55.54H92.8719L92.7365 63.4483C92.7365 66.8621 96.3031 69.6295 100.703 69.6295Z",
  fill: "#F5F5F5"
}), /*#__PURE__*/_jsx("path", {
  d: "M44.3982 63.4483L41.3986 63.397L41.3982 63.4227V63.4483H44.3982ZM28.4658 63.4483L25.4663 63.397L25.4658 63.4227V63.4483H28.4658ZM28.6012 55.54V52.54H25.6521L25.6016 55.4886L28.6012 55.54ZM44.5335 55.54L47.5331 55.5913L47.5853 52.54H44.5335V55.54ZM76.5335 63.4483L73.534 63.397L73.5335 63.4227V63.4483H76.5335ZM60.6012 63.4483L57.6016 63.397L57.6012 63.4227V63.4483H60.6012ZM60.7365 55.54V52.54H57.7874L57.737 55.4886L60.7365 55.54ZM76.6689 55.54L79.6684 55.5913L79.7206 52.54H76.6689V55.54ZM108.669 63.4483L105.669 63.397L105.669 63.4227V63.4483H108.669ZM108.804 55.54L111.804 55.5913L111.856 52.54H108.804V55.54ZM92.8719 55.54V52.54H89.9228L89.8723 55.4886L92.8719 55.54ZM92.7365 63.4483L89.737 63.397L89.7365 63.4227V63.4483H92.7365ZM36.432 72.6295C41.7358 72.6295 47.3982 69.1826 47.3982 63.4483H41.3982C41.3982 64.5416 39.9273 66.6295 36.432 66.6295V72.6295ZM25.4658 63.4483C25.4658 69.1826 31.1282 72.6295 36.432 72.6295V66.6295C32.9366 66.6295 31.4658 64.5416 31.4658 63.4483H25.4658ZM25.6016 55.4886L25.4663 63.397L31.4654 63.4997L31.6007 55.5913L25.6016 55.4886ZM44.5335 52.54H28.6012V58.54H44.5335V52.54ZM47.3977 63.4997L47.5331 55.5913L41.5339 55.4886L41.3986 63.397L47.3977 63.4997ZM68.5674 72.6295C73.8712 72.6295 79.5335 69.1826 79.5335 63.4483H73.5335C73.5335 64.5416 72.0627 66.6295 68.5674 66.6295V72.6295ZM57.6012 63.4483C57.6012 69.1826 63.2635 72.6295 68.5674 72.6295V66.6295C65.072 66.6295 63.6012 64.5416 63.6012 63.4483H57.6012ZM57.737 55.4886L57.6016 63.397L63.6007 63.4997L63.7361 55.5913L57.737 55.4886ZM76.6689 52.54H60.7365V58.54H76.6689V52.54ZM79.5331 63.4997L79.6684 55.5913L73.6693 55.4886L73.534 63.397L79.5331 63.4997ZM105.669 63.4483C105.669 64.5416 104.198 66.6295 100.703 66.6295V72.6295C106.007 72.6295 111.669 69.1826 111.669 63.4483H105.669ZM105.805 55.4886L105.669 63.397L111.668 63.4997L111.804 55.5913L105.805 55.4886ZM92.8719 58.54H108.804V52.54H92.8719V58.54ZM95.7361 63.4997L95.8714 55.5913L89.8723 55.4886L89.737 63.397L95.7361 63.4997ZM100.703 66.6295C97.2074 66.6295 95.7365 64.5416 95.7365 63.4483H89.7365C89.7365 69.1826 95.3989 72.6295 100.703 72.6295V66.6295Z",
  fill: "white",
  mask: "url(#path-10-inside-1_1220_248767)"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.4655 63.4483C60.4655 66.8621 56.899 69.6295 52.4994 69.6295C48.0998 69.6295 44.5332 66.8621 44.5332 63.4483L44.6685 55.54H60.6009L60.4655 63.4483Z",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.6013 63.4483C92.6013 66.8621 89.0347 69.6295 84.6351 69.6295C80.2355 69.6295 76.6689 66.8621 76.6689 63.4483L76.8043 55.54H92.7366L92.6013 63.4483Z",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.3982 63.4483C44.3982 66.8621 40.8316 69.6295 36.432 69.6295C32.0324 69.6295 28.4658 66.8621 28.4658 63.4483L28.6012 55.54H44.5335L44.3982 63.4483Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.5329 63.4483C76.5329 66.8621 72.9664 69.6295 68.5668 69.6295C64.1672 69.6295 60.6006 66.8621 60.6006 63.4483C60.6006 63.4483 60.7359 55.54 60.7359 55.54C60.7359 55.54 76.6683 55.54 76.6683 55.54C76.6683 55.54 76.5329 63.4483 76.5329 63.4483Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.669 63.4483C108.669 66.8621 105.102 69.6295 100.702 69.6295C96.3029 69.6295 92.7363 66.8621 92.7363 63.4483C92.7363 63.4483 92.8717 55.54 92.8717 55.54C92.8717 55.54 108.804 55.54 108.804 55.54C108.804 55.54 108.669 63.4483 108.669 63.4483Z",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.5727 45.9946C35.1563 45.1034 35.5658 44.486 35.6536 44.3784C36.2652 43.6283 37.1956 43.191 38.1798 43.191H98.856C99.8425 43.191 100.768 43.6827 101.339 44.5106C106.625 51.5918 109.104 55.1825 108.775 55.2827C108.283 55.433 28.2007 55.5363 28.3923 55.3009C28.399 55.2925 28.4167 55.2714 28.4445 55.2384C28.8001 54.8162 30.3567 52.4538 31.9346 50.0381L34.5727 45.9946Z",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M121.8 66.9157L116.52 61.6354",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("circle", {
  cx: "109.918",
  cy: "55.0229",
  r: "8.45768",
  fill: "white",
  stroke: "white",
  strokeWidth: "3"
}), /*#__PURE__*/_jsx("circle", {
  cx: "109.918",
  cy: "55.0229",
  r: "9.95768",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("rect", {
  x: "121.108",
  y: "62.6515",
  width: "11.6764",
  height: "5.03714",
  rx: "2",
  transform: "rotate(45 121.108 62.6515)",
  fill: "white",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M104.937 60.1493L114.939 49.9828",
  stroke: "#333333",
  strokeWidth: "1.5"
}), /*#__PURE__*/_jsx("path", {
  d: "M114.899 60.1493L104.897 49.9828",
  stroke: "#333333",
  strokeWidth: "1.5"
})));
const illustrations = new Map();
const superIllustrations = {
  mobile: /*#__PURE__*/_jsx(NoListingSuperSmall, {}),
  desktop: /*#__PURE__*/_jsx(NoListingSuperLarge, {})
};
const affiliateEmptyState = {
  mobile: /*#__PURE__*/_jsx(NoListingSmall, {}),
  desktop: /*#__PURE__*/_jsx(NoListingSmall, {})
};
illustrations.set('super_partner-empty-state', superIllustrations);
illustrations.set('super-empty-state', superIllustrations);
illustrations.set('affiliate-empty-state', affiliateEmptyState);
const getIllustrationByDevice = (name, isDesktop) => {
  var _illustrations$get;
  const Icons = (_illustrations$get = illustrations.get(name)) !== null && _illustrations$get !== void 0 ? _illustrations$get : {};
  return isDesktop ? Icons.desktop : Icons.mobile;
};
const EmptyState = _ref => {
  let {
    cta,
    title,
    description,
    image,
    isDesktop
  } = _ref;
  const EmptyStateClass = classNames('empty-state', {
    'empty-state--super': image === null || image === void 0 ? void 0 : image.includes('super'),
    'empty-state--affiliate': image === null || image === void 0 ? void 0 : image.includes('affiliate')
  });
  const Icon = getIllustrationByDevice(image, isDesktop);
  return /*#__PURE__*/_jsx("div", {
    className: EmptyStateClass
  }, void 0, Icon, /*#__PURE__*/_jsx("h1", {}, void 0, title), /*#__PURE__*/_jsx("p", {}, void 0, description), /*#__PURE__*/_jsx(Button$1, {
    href: cta === null || cta === void 0 ? void 0 : cta.link,
    size: "medium"
  }, void 0, cta === null || cta === void 0 ? void 0 : cta.label));
};
var _Pill;
const AffiliateFeeInfo = _ref => {
  let {
    information,
    report_link: reportLink
  } = _ref;
  const {
    text,
    tooltip
  } = information;
  const {
    content
  } = tooltip;
  const {
    text: reportText,
    url
  } = reportLink;
  const affiliateInfoClass = classNames('affiliate-information');
  return /*#__PURE__*/_jsx("div", {
    className: "affiliate-container"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: affiliateInfoClass
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: `${affiliateInfoClass}__infotext`
  }, void 0, /*#__PURE__*/_jsx(Tooltip$1, {
    content: content,
    side: "bottomLeft",
    type: "dark"
  }, void 0, _Pill || (_Pill = /*#__PURE__*/_jsx(Pill, {
    color: "accent",
    contentType: "icon",
    size: "small"
  }))), /*#__PURE__*/_jsx("div", {
    className: `${affiliateInfoClass}__infotext-content`
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: `${affiliateInfoClass}__infotext-content-message`
  }, void 0, text), /*#__PURE__*/_jsx("span", {
    className: `${affiliateInfoClass}__report`
  }, void 0, /*#__PURE__*/_jsx("a", {
    "data-testid": "report-link",
    target: "_blank",
    rel: "noreferrer",
    href: url
  }, void 0, reportText))))));
};
AffiliateFeeInfo.defaultProps = {
  reportLink: {
    reportText: '',
    url: ''
  },
  information: {
    icon: '',
    text: '',
    tooltip: {
      content: ''
    }
  }
};
const COMPONENTS_TABS = {
  segmented_control: 'segmented_control',
  tabs: 'tabs'
};
const MenuTab = _ref => {
  var _tabs$defaultSelected, _tabs$;
  let {
    behavior_mobile: behaviorMobile,
    behavior_desktop: behaviorDesktop,
    segment_type: segmentType = 'light',
    default_selected_tab: defaultSelectedTab = COMPONENTS_TABS.segmented_control,
    sr_label: srLabel,
    component_type: componentType,
    deviceType,
    tabs,
    onChange
  } = _ref;
  if (!tabs.length) return null;
  const defaultSelected = tabs.length >= defaultSelectedTab ? (_tabs$defaultSelected = tabs[defaultSelectedTab]) === null || _tabs$defaultSelected === void 0 ? void 0 : _tabs$defaultSelected.name : (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.name;
  const MenuTabClass = classNames('menu-tabs');
  const behavior = deviceType === 'desktop' ? behaviorDesktop : behaviorMobile;
  const handleChange = event => {
    const tabSelected = tabs.find(tab => tab.name === event.target.value);
    onChange === null || onChange === void 0 || onChange(tabSelected);
  };
  const renderSegment = tab => {
    const {
      id,
      name,
      disabled
    } = tab;
    return /*#__PURE__*/_jsx(Segment, {
      text: name,
      value: name,
      disabled: disabled
    }, id);
  };
  const renderTab = tab => {
    const {
      id,
      name,
      disabled
    } = tab;
    return /*#__PURE__*/_jsx(Tab, {
      onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(tab),
      title: name,
      disabled: disabled
    }, id);
  };
  return /*#__PURE__*/_jsx("div", {
    className: MenuTabClass
  }, void 0, componentType === COMPONENTS_TABS.segmented_control && /*#__PURE__*/_jsx(SegmentedControl, {
    name: srLabel,
    type: segmentType,
    widthBehavior: behavior,
    defaultValue: defaultSelected,
    onChange: handleChange
  }, void 0, tabs === null || tabs === void 0 ? void 0 : tabs.map((tab, index) => renderSegment(tab))), componentType === COMPONENTS_TABS.tabs && /*#__PURE__*/_jsx(Tabs, {
    srLabel: srLabel,
    behavior: behavior,
    defaultSelectedTab: defaultSelectedTab
  }, void 0, tabs === null || tabs === void 0 ? void 0 : tabs.map((tab, index) => renderTab(tab))));
};
var _div, _Close$1;
const namespace$5 = 'ui-ms-bottom-sheet-header';
const BottomSheetHeader = _ref => {
  let {
    closeButtonSrLabel,
    onClose,
    title,
    hasSwiper,
    isRepurchase
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(namespace$5, {
      [`${namespace$5}--no-swipper`]: !hasSwiper
    })
  }, void 0, hasSwiper && (_div || (_div = /*#__PURE__*/_jsx("div", {
    className: `${namespace$5}__swiper`
  }))), /*#__PURE__*/_jsx("div", {
    className: `${namespace$5}__title-container`
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: classNames(`${namespace$5}__title`, {
      'repurchase-bs-title': isRepurchase
    })
  }, void 0, title), !isRepurchase && /*#__PURE__*/_jsx("button", {
    "data-testid": "button-close",
    "aria-label": closeButtonSrLabel,
    className: `${namespace$5}__close`,
    onClick: onClose
  }, void 0, _Close$1 || (_Close$1 = /*#__PURE__*/_jsx(Close20, {
    "aria-hidden": true
  })))));
};
const _excluded = ["children", "className"];
const RepurchaseInfoTitle = _ref => {
  let {
      children,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx("h2", _objectSpread(_objectSpread({}, props), {}, {
    className: className,
    children: children
  }));
};
const RepurchaseInfoLink = _ref => {
  let {
    redirectLink,
    label,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("a", {
    className: className,
    href: redirectLink,
    target: "_top"
  }, void 0, (label === null || label === void 0 ? void 0 : label.text) && /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      "aria-hidden": true
    }, void 0, label.text), /*#__PURE__*/_jsx("span", {
      className: "andes-visually-hidden"
    }, void 0, label.accessibility_text)]
  }));
};
const namespace$4 = 'ui-ms-repurchase-info';
const RepurchaseInfo = _ref => {
  let {
    title,
    subtitle,
    buttonLabel,
    variation,
    redirectLink
  } = _ref;
  const buttonClasses = classNames(`${namespace$4}__link`, `${namespace$4}__link--${variation}`, 'link-overlay');
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace$4}--${variation}`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace$4}__content--${variation}`
  }, void 0, title && /*#__PURE__*/_jsx(RepurchaseInfoTitle, {
    className: `${namespace$4}__title--${variation}`
  }, void 0, title), subtitle && /*#__PURE__*/_jsx("span", {
    className: `${namespace$4}__subtitle--${variation}`
  }, void 0, subtitle)), redirectLink && /*#__PURE__*/_jsx(RepurchaseInfoLink, {
    className: buttonClasses,
    redirectLink: redirectLink,
    label: buttonLabel
  }));
};
const layoutTypesConst = ['stacked', 'grid'];
const modifiersConst = ['square', 'circle'];
const variationsConst = ['desktop', 'mobile', 'bottomsheet'];
PropTypes.oneOf(variationsConst).isRequired;
const itemType = PropTypes.shape({
  item_id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  images: PropTypes.shape({
    mobile: PropTypes.shape({
      source: PropTypes.string,
      id: PropTypes.string
    }),
    desktop: PropTypes.shape({
      source: PropTypes.string,
      id: PropTypes.string
    })
  }).isRequired,
  rank: PropTypes.string
});
({
  layoutType: PropTypes.oneOf(layoutTypesConst),
  modifier: PropTypes.oneOf(modifiersConst),
  containerSize: PropTypes.number,
  visibleItems: PropTypes.arrayOf(itemType),
  thumbnailClass: PropTypes.string,
  overflowValue: PropTypes.number
});
const namespace$3 = 'ui-ms-repurchase-thumbnail';
const RepurchaseThumbnails = _ref => {
  var _style$itemModifier;
  let {
    variation,
    layoutType,
    modifier,
    containerSize,
    visibleItems,
    thumbnailClass,
    overflowValue,
    style
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace$3}__${thumbnailClass}--${variation}`,
    "aria-hidden": true
  }, void 0, /*#__PURE__*/_jsx(ThumbnailMultiple, {
    type: layoutType,
    containerSize: containerSize,
    modifier: (_style$itemModifier = style === null || style === void 0 ? void 0 : style.itemModifier) !== null && _style$itemModifier !== void 0 ? _style$itemModifier : modifier,
    overflow: overflowValue
  }, void 0, visibleItems === null || visibleItems === void 0 ? void 0 : visibleItems.map(item => {
    var _item$images$String;
    const image = (_item$images$String = item.images[String(variation)]) !== null && _item$images$String !== void 0 ? _item$images$String : item.images.mobile;
    return /*#__PURE__*/_jsx(Thumbnail, {}, image === null || image === void 0 ? void 0 : image.source, /*#__PURE__*/_jsx(Image, {
      src: image === null || image === void 0 ? void 0 : image.source,
      alt: image === null || image === void 0 ? void 0 : image.imageAlt,
      lazyload: "off"
    }));
  })));
};
const namespace$2 = 'ui-ms-repurchase';
const variationsConfig = {
  desktop: {
    layoutType: 'grid',
    overflow: 4,
    containerSize: 64,
    shadow: 'flat',
    paddingSize: 24,
    backgroundColor: 'default',
    modifier: 'square'
  },
  mobile: {
    layoutType: 'grid',
    overflow: 3,
    containerSize: 64,
    shadow: 'outline',
    paddingSize: 16,
    backgroundColor: 'blue',
    modifier: 'square'
  },
  bottomsheet: {
    layoutType: 'stacked',
    overflow: 2,
    containerSize: 24,
    shadow: 'outline',
    paddingSize: 12,
    backgroundColor: 'default',
    modifier: 'circle'
  }
};
const normalizeStyleValues = style => {
  var _style$background_col, _style$chevron_direct, _style$item_modifier;
  if (!style) return null;
  return {
    backgroundColor: (_style$background_col = style.background_color) === null || _style$background_col === void 0 ? void 0 : _style$background_col.toLowerCase(),
    chevronDirection: (_style$chevron_direct = style.chevron_direction) === null || _style$chevron_direct === void 0 ? void 0 : _style$chevron_direct.toLowerCase(),
    itemModifier: (_style$item_modifier = style.item_modifier) === null || _style$item_modifier === void 0 ? void 0 : _style$item_modifier.toLowerCase()
  };
};
const withRepurchaseVariations = Component => {
  const RepurchaseWithVariation = props => {
    var _normalizedStyle$back;
    const {
      variation,
      items,
      repurchase_count: repurchaseCount,
      style
    } = props;
    const normalizedStyle = normalizeStyleValues(style);
    const getMaxRenderItems = () => {
      if (variation !== 'bottomsheet') {
        if (repurchaseCount > 4) {
          return 3;
        }
        return 4;
      }
      if (repurchaseCount > 3) {
        return 2;
      }
      return 3;
    };
    const currentVariation = variationsConst.includes(variation) ? variationsConfig[String(variation)] : variationsConfig.desktop;
    const getThumbnailSizeClass = itemCount => {
      if (itemCount === 1) {
        return 'thumbnail-large';
      }
      if (itemCount === 2) {
        return 'thumbnail-small-thumbnail-reduced-height';
      }
      return 'thumbnail-small';
    };
    const maxRenderItems = getMaxRenderItems();
    const visibleItems = items === null || items === void 0 ? void 0 : items.slice(0, maxRenderItems);
    const totalItems = (items === null || items === void 0 ? void 0 : items.length) >= 4 ? repurchaseCount : 0;
    const extraItemsCount = Math.min(Math.max(totalItems - maxRenderItems, 0), 99);
    const thumbnailClass = getThumbnailSizeClass(items === null || items === void 0 ? void 0 : items.length);
    const overflowValue = extraItemsCount > 0 ? extraItemsCount : undefined;
    const cardClasses = classNames(`${namespace$2}__card`, `${namespace$2}__card--${variation}`, {
      [`${namespace$2}__card--no-style`]: !style
    }, `${namespace$2}-background--${(_normalizedStyle$back = normalizedStyle === null || normalizedStyle === void 0 ? void 0 : normalizedStyle.backgroundColor) !== null && _normalizedStyle$back !== void 0 ? _normalizedStyle$back : currentVariation.backgroundColor}`);
    const contentClasses = classNames(`${namespace$2}__content--${variation}`, {
      [`${namespace$2}__content--no-style`]: !style
    });
    const renderChevron = () => {
      if (!(normalizedStyle !== null && normalizedStyle !== void 0 && normalizedStyle.chevronDirection)) return null;
      const chevronIcons = {
        desktop: {
          right: ChevronRight32,
          left: ChevronLeft32
        },
        default: {
          right: ChevronRight20,
          left: ChevronLeft20
        }
      };
      const iconSet = chevronIcons[variation === 'desktop' ? 'desktop' : 'default'];
      const ChevronIcon = iconSet[normalizedStyle.chevronDirection];
      return /*#__PURE__*/_jsx("div", {
        className: classNames(`${namespace$2}__chevron`, `${namespace$2}__chevron--${variation}`, `${namespace$2}__chevron--${normalizedStyle.chevronDirection}`, `${namespace$2}__chevron--${normalizedStyle.chevronDirection}--${variation}`, {
          [`${namespace$2}__chevron--inverted`]: variation === 'desktop'
        })
      }, void 0, /*#__PURE__*/_jsx(ChevronIcon, {}));
    };
    const newProps = _objectSpread(_objectSpread({}, props), {}, {
      shadow: currentVariation.shadow,
      variationProps: _objectSpread(_objectSpread({}, currentVariation), {}, {
        visibleItems,
        thumbnailClass,
        overflowValue,
        cardClasses,
        contentClasses,
        chevronElement: renderChevron(),
        style: normalizedStyle
      })
    });
    return /*#__PURE__*/jsx(Component, _objectSpread({}, newProps));
  };
  return RepurchaseWithVariation;
};
const Repurchase = _ref => {
  let {
    variation,
    variationProps,
    title,
    subtitle,
    modifier,
    buttonLabel,
    redirectLink,
    onClose
  } = _ref;
  const {
    shadow,
    paddingSize,
    cardClasses,
    contentClasses,
    chevronElement
  } = variationProps;
  return /*#__PURE__*/_jsx(Card$1, {
    role: "button",
    className: cardClasses,
    paddingSize: paddingSize,
    shadow: shadow,
    title: title,
    onClick: onClose
  }, void 0, /*#__PURE__*/_jsx(CardContent, {
    className: contentClasses
  }, void 0, /*#__PURE__*/_jsx(RepurchaseInfo, {
    title: title,
    subtitle: subtitle,
    buttonLabel: buttonLabel,
    variation: variation,
    redirectLink: redirectLink
  }), /*#__PURE__*/jsx(RepurchaseThumbnails, _objectSpread({
    modifier: modifier,
    variation: variation
  }, variationProps)), chevronElement));
};
var Repurchase$1 = withRepurchaseVariations(Repurchase);
var _PlaceholderImage;
const Card = _ref => {
  let {
    label,
    namespace,
    onRedirect,
    picture,
    url
  } = _ref;
  const handleClick = () => {
    if (onRedirect) {
      onRedirect(url);
    }
  };
  return /*#__PURE__*/_jsx("li", {
    className: `${namespace}__card`
  }, void 0, picture ? /*#__PURE__*/_jsx(Image, {
    src: picture.src,
    src2x: picture.src2x,
    alt: label,
    lazyload: "on",
    title: "",
    height: "48",
    width: "48"
  }) : _PlaceholderImage || (_PlaceholderImage = /*#__PURE__*/_jsx(PlaceholderImage48, {})), /*#__PURE__*/_jsx("button", {
    className: `${namespace}__link`,
    onClick: handleClick,
    role: "link"
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: `${namespace}__label`
  }, void 0, label)));
};
const constants = {
  BOTTOM_SHEET_REDIRECT: 'bs:redirect',
  BOTTOM_SHEET_CLOSE: 'bs:close'
};
var constants_1 = constants;
var _Close;
const namespace$1 = 'ui-ms-bottom-sheet-content';
const BottomSheetContent = _ref => {
  let {
    closeButtonSrLabel,
    corridors,
    onClose,
    onRedirect,
    title,
    hasSwiper,
    isRepurchase = false,
    isWebView,
    repurchaseData = {}
  } = _ref;
  const {
    variation,
    items,
    title: repurchaseTitle,
    subtitle,
    repurchase_count: repurchaseCount,
    redirectLink,
    style
  } = repurchaseData;
  const handleCloseBs = () => {
    window.parent.postMessage({
      name: constants_1.BOTTOM_SHEET_CLOSE
    }, '*');
  };
  const handleClose = isWebView ? onClose : handleCloseBs;
  return /*#__PURE__*/_jsx("div", {
    className: namespace$1
  }, void 0, isRepurchase && repurchaseData && /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: `${namespace$1}__close-container`
    }, void 0, /*#__PURE__*/_jsx("button", {
      "data-testid": "button-close",
      "aria-label": closeButtonSrLabel,
      onClick: handleClose,
      className: `${namespace$1}__close-button`
    }, void 0, _Close || (_Close = /*#__PURE__*/_jsx(Close20, {
      "aria-hidden": true
    })))), /*#__PURE__*/_jsx("div", {
      className: `${namespace$1}__repurchase-widget`
    }, void 0, /*#__PURE__*/_jsx(Repurchase$1, {
      variation: variation,
      items: items,
      title: repurchaseTitle,
      subtitle: subtitle,
      redirectLink: redirectLink,
      repurchase_count: repurchaseCount,
      onClose: handleClose,
      style: style
    }))]
  }), (title || isRepurchase) && /*#__PURE__*/_jsx(BottomSheetHeader, {
    closeButtonSrLabel: closeButtonSrLabel,
    onClose: onClose,
    title: title,
    hasSwiper: hasSwiper,
    isRepurchase: isRepurchase
  }), /*#__PURE__*/_jsx("ul", {
    className: classNames(`${namespace$1}__list`, {
      [`${namespace$1}__list--spacing`]: !title
    })
  }, void 0, corridors === null || corridors === void 0 ? void 0 : corridors.map(corridor => /*#__PURE__*/jsx(Card, _objectSpread({
    namespace: namespace$1,
    onRedirect: onRedirect
  }, corridor), corridor.url))));
};
const BottomSheetContext = /*#__PURE__*/React.createContext({});
const BottomSheetProvider = _ref => {
  let {
    children
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const [url, setUrl] = useState('');
  return /*#__PURE__*/_jsx(BottomSheetContext.Provider, {
    value: {
      isOpen,
      setIsOpen,
      url,
      setUrl
    }
  }, void 0, children);
};
var _BottomSheetHeader;
const namespace = 'ui-ms-bottom-sheet';
const BottomSheet = _ref => {
  let {
    onClose,
    open,
    url,
    title,
    initialHeight,
    closeButtonSrLabel,
    isRepurchase = false
  } = _ref;
  return /*#__PURE__*/_jsx(AndesBottomSheet, {
    className: namespace,
    closable: !isRepurchase,
    open: open,
    initialHeight: initialHeight,
    closeButtonSrLabel: closeButtonSrLabel,
    onClose: onClose,
    title: !isRepurchase ? title : '',
    header: isRepurchase ? _BottomSheetHeader || (_BottomSheetHeader = /*#__PURE__*/_jsx(BottomSheetHeader$1, {})) : /*#__PURE__*/_jsx(BottomSheetHeader$1, {
      close: true
    }, void 0, title)
  }, void 0, /*#__PURE__*/_jsx("iframe", {
    className: `${namespace}__iframe`,
    src: url,
    title: title
  }));
};
const BottomSheetIframe = _ref => {
  let {
    height,
    title,
    setIsOpen,
    isOpen,
    url,
    closeButtonSrLabel,
    isRepurchase
  } = _ref;
  const handleClose = () => setIsOpen(false);
  useEffect(() => {
    const callback = _ref2 => {
      let {
        data
      } = _ref2;
      if (data.name === constants_1.BOTTOM_SHEET_REDIRECT) {
        setIsOpen(false);
        window.location = data.url;
      }
      if (data.name === constants_1.BOTTOM_SHEET_CLOSE) {
        setIsOpen(false);
      }
    };
    window.addEventListener('message', callback);
    return () => window.removeEventListener('message', callback);
  }, [setIsOpen]);
  return /*#__PURE__*/_jsx(BottomSheet, {
    onClose: handleClose,
    initialHeight: `${height}%`,
    closeButtonSrLabel: closeButtonSrLabel,
    title: title,
    open: isOpen,
    url: url,
    isRepurchase: isRepurchase
  });
};
const withBottomSheetContext = Component => {
  const ComponentWithBottomSheetContext = props => {
    const {
      setUrl,
      setIsOpen,
      isOpen,
      url
    } = useContext(BottomSheetContext);
    const newProps = _objectSpread(_objectSpread({}, props), {}, {
      setUrl,
      setIsOpen,
      isOpen,
      url
    });
    return /*#__PURE__*/jsx(Component, _objectSpread({}, newProps));
  };
  return ComponentWithBottomSheetContext;
};
const ARTICULE_SUBSTRING = 'articulo.';
const PRODUCT_SUBSTRING = 'produto.';
const getItemDeeplink = _ref => {
  let {
    item,
    isWebview
  } = _ref;
  const {
    id,
    url
  } = item;
  if (isWebview && (url !== null && url !== void 0 && url.includes(ARTICULE_SUBSTRING) || url !== null && url !== void 0 && url.includes(PRODUCT_SUBSTRING))) {
    const fragment = url.split('#')[1];
    const urlEncode = encodeURIComponent(url);
    const newUrl = `meli://items-core/${id}/?forceInApp=true#${fragment}&permalink=${urlEncode}`;
    return newUrl;
  }
  if (isWebview && url !== null && url !== void 0 && url.includes('/p/')) {
    const initialUrl = url.split('/p/')[1];
    const splitUrl = initialUrl.split('/?');
    const productId = splitUrl[0];
    const fragments = splitUrl[1];
    const newUrl = `meli://products/${productId}/?${fragments}`;
    return newUrl;
  }
  return url;
};

/* temporal fix for deeplinks generations */
const rebuildChildrenProps = _ref2 => {
  var _children$;
  let {
    children,
    isWebview
  } = _ref2;
  const {
    recommendations
  } = ((_children$ = children[0]) === null || _children$ === void 0 || (_children$ = _children$.props) === null || _children$ === void 0 || (_children$ = _children$.node) === null || _children$ === void 0 || (_children$ = _children$.properties) === null || _children$ === void 0 || (_children$ = _children$.recommendations) === null || _children$ === void 0 ? void 0 : _children$.recommendation_info) || {};
  if (recommendations && isWebview) {
    const newRecommendations = [];
    recommendations.forEach(item => {
      const deeplink = getItemDeeplink({
        item,
        isWebview
      });
      newRecommendations.push(_objectSpread(_objectSpread({}, item), {}, {
        url: deeplink
      }));
    });
    const newChildren = [...children];
    newChildren[0].props.node.properties.recommendations.recommendation_info.recommendations = newRecommendations;
    return newChildren;
  }
  return children;
};
export { AffiliateFeeInfo, BottomSheetContent, BottomSheetContext, BottomSheetIframe, BottomSheetProvider, EmptyState, MenuTab, ProfileHeader, Repurchase$1 as Repurchase, Sidebar as SideBar, getItemDeeplink, rebuildChildrenProps, withBottomSheetContext };
